import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/esnext.json.parse.js";
import 'ol/ol.css';
import { Map, View } from 'ol';
import VectorLayer from 'ol/layer/Vector';
import TileLayer from 'ol/layer/Tile';
import LayerImage from 'ol/layer/Image';
import VectorSource from 'ol/source/Vector';
import SourceImagestatic from 'ol/source/ImageStatic';
import XYZ from 'ol/source/XYZ';
import { defaults } from 'ol/control';
import Attribution from 'ol/control/Attribution';
import { transformExtent, fromLonLat, transform, toLonLat } from 'ol/proj';
import Projection from 'ol/proj/Projection';
// import Point from 'ol/geom/Point'
import { Circle, Point, LineString, GeometryCollection, Polygon } from 'ol/geom';
import Style from 'ol/style/Style';
import StyleIcon from 'ol/style/Icon';
import StyleText from 'ol/style/Text';
import StyleFill from 'ol/style/Fill';
import StyleStroke from 'ol/style/Stroke';
import StyleCircle from 'ol/style/Circle';
import { Circle as CircleStyle } from 'ol/style';
import Feature from 'ol/Feature';
import { GeoJSON } from 'ol/format';
import Overlay from 'ol/Overlay';
import { all } from 'ol/loadingstrategy';
import { Draw, Snap, Modify, Select, DragBox, Translate } from 'ol/interaction';
import { platformModifierKeyOnly, click, shiftKeyOnly, always } from 'ol/events/condition';
import { getWidth, boundingExtent, getCenter, getHeight } from 'ol/extent';
import * as olRender from 'ol/render';
import axios from 'axios';
import { gaoDeToBaidu, bd_decrypt, loadScript, getImg, createBezierCurvePoints, getPointsBetweenLatLong, handleHttp, convertLinearGradientToJson } from '@/utils/utils';
import { mapState, mapGetters, mapMutations } from 'vuex';
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
import 'ol-ext/dist/ol-ext.css';
import Transform from 'ol-ext/interaction/Transform';
import { getPan, getPinchRotate, getdragPan } from '@/view/map/js/common';
import * as turf from '@turf/turf';
import cdata from './common.js';
let _ = require('lodash');
export default {
  name: 'mapv2assembly',
  props: {
    id: {
      type: Number,
      default: 0
    },
    zoom: {
      type: Number,
      default: 5
    },
    minZoom: {
      type: Number,
      default: 0
    },
    maxZoom: {
      type: Number,
      default: 28
    },
    center: {
      type: Array,
      default: [116.3683244, 39.915085]
    },
    extent: {
      type: Array,
      default: [73.502355, 3.397162, 135.09567, 53.563269]
    },
    showgdtilelayer: {
      type: Boolean,
      default: false
    },
    showstaticlayer: {
      type: Boolean,
      default: false
    },
    staticimage: {
      type: String,
      default: ''
    },
    showgeojsonlayer: {
      type: Boolean,
      default: false
    },
    geojson: {
      type: Object,
      default: {}
    },
    drawelement: {
      type: Object,
      default: {}
    },
    showroutelayer: {
      type: Boolean,
      default: false
    },
    showshadowlayer: {
      type: Object,
      default: {}
    },
    adcode: {
      type: String,
      default: '100000'
    },
    streetcode: {
      type: Array,
      default: []
    },
    pointlist: {
      type: Array,
      default: []
    },
    scale: {
      type: Boolean,
      default: false
    },
    rotate: {
      type: Boolean,
      default: false
    },
    translate: {
      type: Boolean,
      default: false
    },
    mapstyle: {
      type: Object,
      default: {}
    },
    culturallist: {
      type: Array,
      default: []
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    location: {
      type: Object,
      default: {}
    },
    rotation: {
      type: Number,
      default: 0
    }
  },
  components: {},
  meta: {
    title: 'openlayermap组件'
  },
  data() {
    return {
      mapcontainer: '',
      map: '',
      defaultlayer: [],
      staticImageLayer: [],
      iconSource: '',
      iconLayer: [],
      style: {},
      cfeature: null,
      timer: null,
      timers: [],
      defaultZoom: 0,
      moveendflag: true,
      drawflag: false,
      drawSource: '',
      drawLayer: [],
      drawsketch: '',
      drawinter: '',
      snapinter: '',
      modifyinter: '',
      helpTooltip: '',
      helpTooltipElement: '',
      deleteflag: false,
      selectinter: '',
      selectedFeatures: [],
      dragboxinter: '',
      drawstyle: {
        color: 'rgba(0,0,0,0.5)',
        width: 1,
        lineDash: [2, 2]
      },
      drawtextflag: false,
      drawtextsingleflag: false,
      translateinter: '',
      isnotclick: false,
      currentTextstyle: {
        align: 0,
        // 排列方式 0纵向 1横向
        fontSize: 12,
        color1: 'rgba(0, 0, 0, 1)',
        color2: 'rgba(123, 33, 33, 1)'
      },
      defaulticon: 'https://p.ananas.chaoxing.com/star3/origin/6e34ee5cc29e45f92fc9347bf35febfb.png',
      overlay: 'undefined',
      findex: 0,
      CircleRadius: 5,
      lightIcon: [require('@/assets/map/138053/color1.gif'), require('@/assets/map/138053/color2.gif'), require('@/assets/map/138053/color3.gif')],
      hoverImg: '',
      hoverImgList: [],
      routeSource: '',
      routeLayer: [],
      locationSource: '',
      locationLayer: [],
      locationicon: 'https://p.ananas.chaoxing.com/star3/origin/8077173b8e82056110d8b5ea170d68c4.png',
      animating: false,
      movedefaulticon: 'https://p.ananas.chaoxing.com/star3/origin/da0e3c42e5eca5562aeadbbe88bf1def.png',
      moveicon: 'https://p.ananas.chaoxing.com/star3/origin/da0e3c42e5eca5562aeadbbe88bf1def.png',
      nowDate: '',
      moveprogress: '',
      geoMarker: '',
      jsonSource: '',
      jsonLayer: [],
      defaultJsonFeatures: '',
      routeData: [],
      selectIndex: '',
      selectCoords: [],
      selectcurveCoords: [],
      routeStyle: '',
      toolswrap: null,
      modifySource: '',
      curverouteCoords: [],
      jsonfillcolor: [],
      geojsonList: [],
      isSetjsonstyle: false,
      fileImageList: [],
      editMapflag: false,
      editmapcontainer: '',
      editmap: '',
      editiconSource: '',
      editiconLayer: [],
      editpolygonSource: '',
      editpolygonLayer: [],
      editimg: '',
      editimgwdith: 0,
      editimgheight: 0,
      clipImageUrl: '',
      transforminteration: '',
      polygonSource: '',
      polygonLayer: [],
      dragpicpolygonSource: '',
      dragpicpolygonLayer: [],
      dragpicSource: '',
      dragpicLayer: [],
      allpath: [],
      // 记录当前路线所有点 轨迹图标动画用
      currentPath: {},
      // 记录当前线路当前线段数据
      pathIndex: 0,
      // 记录当前线路线段索引
      shadowjsonSource: '',
      shadowjsonLayer: [],
      decorationSource: '',
      decorationLayer: [],
      lastPointIds: new Set()
    };
  },
  created() {
    loadScript(`${process.env.NODE_ENV === 'development' ? '/fileapi' : location.origin}/frontendTest1/openlayers/js/gifler.min.js`);
    if (this.$route.query.fid === '222755') this.hoverImgList = cdata.maphoverimages;
    if (this.$route.query.fid === '331112') this.hoverImgList = cdata.customMapenshizhouhoverImg;
    this.fileImageList = cdata.fillimageData;
  },
  computed: {
    ...mapGetters(['mapv2info']),
    mapv2infoViewchange() {
      const {
        zoom,
        minZoom,
        maxZoom,
        center,
        rotation
      } = this.mapv2info.view;
      return {
        zoom,
        minZoom,
        maxZoom,
        center,
        rotation
      };
    }
  },
  mounted() {
    // console.log(`this.mapv2info.form`, this.mapv2info.form)
    this.jsonfillcolor = _.cloneDeep(this.mapv2info.form.fillcolor);
    // console.log(`this.jsonfillcolor`, this.jsonfillcolor)
    // this.isSetjsonstyle = (this.jsonfillcolor === '' || this.jsonfillcolor === undefined) ? false : true
    this.initMap();
    this.style = this.id === 0 ? this.mapv2info.style : this.mapstyle;
    // console.log(`this.style`, this.style);
    if (this.style.routemoveicon !== undefined && this.style.routemoveicon.length > 0) this.moveicon = this.style.routemoveicon[0].fileUrl;
  },
  watch: {
    pointlist: {
      handler(val) {
        console.log(`pointlist`);
        console.log(val);
        this.syncPointFeatures(val);
      },
      deep: true
    },
    'showgdtilelayer': {
      handler(val) {
        // console.log(`showgdtilelayer`, val);
        this.map.getLayers().getArray().forEach(item => {
          if (item.getClassName() === 'tile') item.setVisible(val);
        });
      },
      deep: true
    },
    'staticimage': {
      handler(val) {
        console.log(`staticimage`, val);
        console.log(`this.mapv2info.form.mapmodetype`, this.mapv2info.form.mapmodetype);
        this.staticimageHandle(val, this.setSourceImagestatic(val, transformExtent(this.extent, 'EPSG:4326', 'EPSG:3857')));
      },
      deep: true
    },
    culturallist: {
      handler(val) {
        // console.log(`culturallist`);
        // console.log(val);
        this.createculturalPoint(val);
      },
      deep: true
    },
    showroutelayer: {
      handler(val) {
        console.log(`showgdtilelayer`, val);
        this.map.getLayers().getArray().forEach(item => {
          if (item.getClassName() === 'route') item.setVisible(val);
        });
      },
      deep: true
    },
    location: {
      handler(val) {
        this.loadLocation(val);
      },
      deep: true
    },
    'mapv2info.style.pointpic': {
      handler(val) {
        // console.log(`mapv2info.style.pointpic`, val);
        this.iconSource.clear();
        this.createPoint(this.pointlist);
        if (this.mapv2info.form.cTemplateScore === 1) this.createculturalPoint(this.culturallist);
      },
      deep: true
    },
    'mapv2info.style.pointicon': {
      handler(val) {
        console.log(`mapv2info.style.pointicon`, val);
        this.iconSource.clear();
        this.createPoint(this.pointlist);
      },
      deep: true
    },
    'mapv2info.style.pointtext': {
      handler(val) {
        // console.log(`mapv2info.style.pointtext`, val);
        this.iconSource.clear();
        this.createPoint(this.pointlist);
      },
      deep: true
    },
    'mapv2info.style.pointStyleIndex'(val) {
      // console.log(`mapv2info.style.pointStyleIndex`, val);
      this.iconSource.clear();
      this.createPoint(this.pointlist);
    },
    'mapv2info.style.routemoveicon': {
      handler(val) {
        console.log(`mapv2info.style.routemoveicon`, val);
        this.moveicon = val.length > 0 ? val[0].fileUrl : this.movedefaulticon;
      },
      deep: true
    },
    mapv2infoViewchange() {
      this.updateMap();
    },
    'mapv2info.view.scale'(val) {
      // console.log(`mapv2info.view.scale`, val);
      val ? getPan(this.map) : getPan(this.map, true);
    },
    'mapv2info.view.rotate'(val) {
      // console.log(`mapv2info.view.rotate`, val);
      val ? getPinchRotate(this.map) : getPinchRotate(this.map, true);
    },
    'mapv2info.view.translate'(val) {
      // console.log(`mapv2info.view.translate`, val);
      val ? getdragPan(this.map) : getdragPan(this.map, true);
    },
    'mapv2info.drawlayer.toolsIndex'(val) {
      // 操作类型 0绘制文字 1绘制线 2删除 3框选 4平移
      // console.log(`mapv2info.drawlayer.toolsIndex`, val);
      if (val === '') return;
      this.changeToolHandle(val);
    },
    'mapv2info.drawlayer.linestyle'(val) {
      // console.log('mapv2info.drawlayer.linestyle')
      // console.log(val)
      if (val) {
        this.drawstyle = val;
        this.drawSource.getFeatures().forEach(feature => {
          if (feature.getGeometry().getType() === 'LineString') feature.setStyle(new Style({
            stroke: new StyleStroke(val)
          }));
          if (feature.getGeometry().getType() === 'Circle') feature.setStyle(new Style({
            fill: new StyleFill({
              color: val.color
            }),
            stroke: new StyleStroke({
              color: val.color,
              width: this.CircleRadius
            })
          }));
        });
      }
    },
    'mapv2info.drawlayer.currentList'(val) {
      // console.log('mapv2info.drawlayer.currentList')
      this.createText(val, 'currentList');
    },
    'mapv2info.drawlayer.drawtextblocksum'(val) {
      // console.log('mapv2info.drawlayer.drawtextblocksum', val)
      this.createText(val, 'drawtextblocksum');
    },
    'mapv2info.drawlayer.showtranfer'(val) {
      // console.log('mapv2info.drawlayer.showtranfer', val)
      if (!val && this.mapv2info.drawlayer.dtext) this.showtexthelp();
    },
    'mapv2info.drawlayer.currentTextstyle': {
      handler(val) {
        // console.log('mapv2info.drawlayer.currentTextstyle')
        // console.log(val)
        if (val) {
          this.currentTextstyle = val;
          this.createText(this.mapv2info.drawlayer.currentList, 'currentList');
        }
      },
      deep: true
    },
    'mapv2info.routeSources': {
      handler(val) {
        if (!this.showroutelayer) return;
        console.log(`mapv2info.routeSources`, val);
        const flag = val.length > 1 ? false : true;
        this.createRoute(val, flag);
      },
      deep: true
    },
    'mapv2info.form.fillcolor': {
      handler(val) {
        console.log(`mapv2info.form.fillcolor`);
        if (val) this.changeMapFillcolor(val);
      },
      deep: true
    },
    'mapv2info.form.filltype': {
      handler(val) {
        console.log(`mapv2info.form.filltype`);
        if (val) this.changeMapfilltype(val);
      },
      deep: true
    },
    'mapv2info.form.clipflag': {
      handler(val) {
        console.log(`mapv2info.form.clipflag`);
        if (val) this.clipImageHandle();
      },
      deep: true
    },
    'mapv2info.form.fillimageindex': {
      handler(val) {
        console.log(`mapv2info.form.fillimageindex`);
        console.log(val);
        if (val && val !== '') {
          console.log(val);
          this.changeMapfillImage(val);
        }
      },
      deep: true
    },
    'mapv2info.form.fillimage': {
      handler(val) {
        console.log(`mapv2info.form.fillimage`);
        console.log(val);
        if (val) {
          this.changeMapfillImage(val);
        }
      },
      deep: true
    },
    'mapv2info.form.mapmodetype': {
      handler(val) {
        console.log(`mapv2info.form.mapmodetype`);
        console.log(val);
        if (val) {
          this.changeMapmodeType(val);
        }
      },
      deep: true
    },
    'mapv2info.form.adjustextent': {
      handler(val) {
        console.log(`mapv2info.form.adjustextent`, val);
        if (val) this.adjustExtent();
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations(['SET_MAPDRAWLAYERITEM', 'SET_MAPROUTECURVE', 'SET_MAPFORMITEM', 'SET_MAPVIEWITEM']),
    /**
     * 初始化地图
     */
    initMap() {
      console.log('初始化地图', this.zoom);
      this.defaultZoom = Math.round(this.zoom);
      // openlayers图层zIndex越大 越靠上
      this.defaultlayer = this.getTileLayer(); // tiles层 1
      this.staticImageLayer = this.getstaticImageLayer(); // 静态图片层 2
      this.shadowjsonLayer = this.getshadowjsonLayer(); // 地图投影层 3
      this.jsonLayer = this.getjsonlayer(); // jsonSource层 4
      const hoverLayer = this.gethoverLayer(); // 鼠标移入图片层 5

      // 地图配置页 jsonSource featuresloadend加载完成后触发
      this.jsonSource.on('featuresloadend', evt => {
        console.log(`this.showshadowlayer`, this.showshadowlayer);
        this.jsonSourceloadend(evt);
        if (this.showshadowlayer.shadowFlag !== undefined) {
          this.changeMapShadowList(this.showshadowlayer);
        }
      });

      // 地图素材图片图层
      this.decorationSource = new VectorSource();
      this.decorationLayer = new VectorLayer({
        source: this.decorationSource,
        className: 'decoration',
        zIndex: 6
      });

      // 地图路线图层
      this.routeSource = new VectorSource();
      this.routeLayer = new VectorLayer({
        source: this.routeSource,
        className: 'route',
        zIndex: 7
      });

      // 地图地点图层
      this.iconSource = new VectorSource();
      this.iconLayer = new VectorLayer({
        source: this.iconSource,
        className: 'icon',
        zIndex: 8
      });

      // 绘制图层 9
      this.drawLayer = this.getDrawLayer();
      this.drawSource.on('change', evt => {
        this.drawSourceChange(evt);
      });

      // 地图真实地点图层
      this.locationSource = new VectorSource();
      this.locationLayer = new VectorLayer({
        source: this.locationSource,
        className: 'location',
        zIndex: 10
      });
      this.mapcontainer = this.$refs[`map${this.id}`];
      console.log(`this.rotation`, this.rotation);
      this.map = new Map({
        layers: [this.defaultlayer, this.shadowjsonLayer, this.staticImageLayer, this.jsonLayer, hoverLayer, this.decorationLayer, this.routeLayer, this.iconLayer, this.drawLayer, this.locationLayer],
        target: this.mapcontainer,
        view: new View({
          center: transform(this.center.map(Number), 'EPSG:4326', 'EPSG:3857'),
          minZoom: this.minZoom,
          maxZoom: this.maxZoom,
          zoom: this.zoom,
          rotation: this.rotation
        }),
        controls: defaults({
          attribution: false
        })
      });
      if (this.adcode === 'region') {
        this.jsonSourceloadend({
          features: this.jsonSource.getFeatures()
        });
        if (this.showshadowlayer.shadowFlag !== undefined) {
          this.changeMapShadowList(this.showshadowlayer);
        }
      }
      this.scale ? getPan(this.map) : getPan(this.map, true);
      this.rotate ? getPinchRotate(this.map) : getPinchRotate(this.map, true);
      // 会导致经纬度 随拖拽不断递增问题 定位到问题 后面解决
      this.translate ? getdragPan(this.map) : getdragPan(this.map, true);
      this.map.on('singleclick', this.singleclick);
      this.map.on('click', this.markerclick);
      this.map.on('pointermove', this.markermove);
      this.map.getLayers().getArray().forEach(item => {
        if (item.getClassName() === 'tile') item.setVisible(this.showgdtilelayer);
        if (item.getClassName() === 'static') item.setVisible(this.showstaticlayer);
        if (item.getClassName() === 'json') {
          item.setVisible(this.showgeojsonlayer);
          if (this.staticimage) item.setOpacity(0);
        }
        if (item.getClassName() === 'hoverimg') item.setVisible(false);
        if (item.getClassName() === 'route') item.setVisible(this.showroutelayer);
      });
      this.map.on('moveend', this.markermoveend);

      // 340879 湖南中医药大学 茶陵县 不处理绘制图层
      if (this.$route.query.fid === '340879') return;
      this.drawfitHandle();
    },
    /**
     * 非1920*1080分辨率且绘制图层有数据时 处理显示范围及位置
     */
    drawfitHandle() {
      if (document.body.clientWidth !== 1920 && this.drawSource !== '' && this.mapstyle.hasOwnProperty('listpos')) {
        let widthflag = document.body.clientWidth <= 1440;
        let listpos = this.mapstyle.listpos;
        let mapPadding = [30, 30, 30, 30];
        let type = listpos.ptype.split('-');
        switch (type[0]) {
          case 'left':
            mapPadding[3] = widthflag <= 1440 ? 430 : 530;
            break;
          case 'right':
            mapPadding[1] = widthflag <= 1440 ? 430 : 530;
            break;
        }
        this.$nextTick(() => {
          this.map.getView().fit(this.drawSource.getExtent(), {
            size: this.map.getSize(),
            padding: mapPadding
          });
        });
      }
    },
    /**
     * 加载高德地图瓦片作为底图
     */
    getTileLayer() {
      return new TileLayer({
        source: new XYZ({
          url: 'http://webrd03.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}'
        }),
        className: 'tile',
        zIndex: 1
      });
    },
    /**
     * 加载静态图片
     */
    getstaticImageLayer() {
      console.log(`this.staticimage`, this.staticimage);
      // 假设你的图层边界在4326下是 [minx, miny, maxx, maxy]
      const layerExtentIn4326 = this.extent;
      // 转换边界的对角点到3857坐标系
      const bottomLeftIn3857 = fromLonLat([layerExtentIn4326[0], layerExtentIn4326[1]]);
      const topRightIn3857 = fromLonLat([layerExtentIn4326[2], layerExtentIn4326[3]]);
      // 创建在3857坐标系下的边界（注意：extent 是 [minx, miny, maxx, maxy]）
      const layerExtentIn3857 = [bottomLeftIn3857[0], bottomLeftIn3857[1], topRightIn3857[0], topRightIn3857[1]];
      // 若url为空 imageExtent设置[]

      let that = this;
      const source = this.setSourceImagestatic(this.staticimage, this.staticimage === '' ? [] : layerExtentIn3857);
      // 监听图片加载完成
      source.on('imageloadend', () => {
        that.$emit('imageLoadEnd', true);
        // 在这里执行您的逻辑
      });
      return new LayerImage({
        source: source,
        opacity: 1,
        className: 'static',
        zIndex: 3
      });
    },
    /**
     * 加载地图投影JSON层级
     * @date 2025-06-26
     */
    getshadowjsonLayer() {
      return new VectorLayer({
        source: this.shadowjsonSource,
        opacity: 1,
        className: 'shadowjson',
        zIndex: 2
      });
    },
    /**
     * 加载GeoJson
     */
    getjsonlayer() {
      if (this.adcode === 'region') {
        this.jsonSource = new VectorSource();
        const features = new GeoJSON().readFeatures(this.geojson);
        this.jsonSource.addFeatures(features);
      } else {
        // 乡镇街道json判断
        if (this.streetcode.length > 0) {
          this.jsonSource = new VectorSource({
            features: new GeoJSON().readFeatures(this.geojson, {
              dataProjection: 'EPSG:4326',
              featureProjection: 'EPSG:3857'
            })
          });
        } else {
          let apiurl = `${process.env.NODE_ENV === 'development' ? '/fileapi' : location.origin}/frontendTest1/openlayers/data/`;
          if (this.adcode.includes(',')) {
            this.jsonSource = new VectorSource();
            let adcodes = _.cloneDeep(this.adcode).split(',');
            let adcodesArr = [];
            adcodes.forEach(elem => {
              adcodesArr.push(`${apiurl}${elem}${this.mapv2info.form.ishaschild === '是' ? '_full' : ''}.json`);
            });
            let that = this;
            adcodesArr.forEach(elem => {
              axios.get(elem).then(res => {
                let jsondata = new GeoJSON().readFeatures(res.data, {
                  dataProjection: 'EPSG:4326',
                  featureProjection: 'EPSG:3857'
                });
                that.mapv2info.form.ishaschild === '是' ? that.jsonSource.addFeatures(jsondata) : that.jsonSource.addFeature(jsondata[0]);
              });
            });
          } else {
            // 省市区县json
            this.jsonSource = new VectorSource({
              format: new GeoJSON(),
              url: `${apiurl}${this.adcode.includes('_full') ? this.adcode.replace('_full', '') : this.adcode}${this.mapv2info.form.ishaschild === '是' ? '_full' : ''}.json`
            });
          }
        }
      }
      console.log(`this.jsonSource`, this.jsonSource);
      return new VectorLayer({
        source: this.jsonSource,
        opacity: 1,
        style: this.jsonstyleFunction(),
        className: 'json',
        zIndex: 4
      });
    },
    jsonstyleFunction() {
      return [new Style({
        stroke: new StyleStroke({
          color: 'rgba(5, 146, 232, 1)',
          width: 1,
          lineDash: [4]
        }),
        fill: new StyleFill({
          color: 'rgba(5, 146, 232, 0.2)'
        })
      })];
    },
    jsonSourceloadend(evt) {
      console.log(`jsonSourceloadend`, evt);
      console.log(`this.jsonfillcolor`, this.jsonfillcolor);
      // 表单未更新字段时不做操作
      if (this.jsonfillcolor === undefined) return;
      const features = evt.features === undefined ? [evt.feature] : evt.features;
      this.defaultJsonFeatures = _.cloneDeep(features);
      evt.features.forEach(feature => {
        this.geojsonList.push({
          code: feature.get('adcode') || feature.get('code'),
          name: feature.get('name'),
          style: [{
            fill: 'rgba(5, 146, 232, 0.2)',
            stroke: {
              color: 'rgba(5, 146, 232, 1)',
              width: 1,
              lineDash: [4, 2]
            }
          }]
        });
      });
      // 新创建 或者 行政区域由一个改为多个时 触发
      if (this.jsonfillcolor === '' || this.jsonfillcolor.length !== this.geojsonList.length) {
        this.SET_MAPFORMITEM({
          fillcolor: this.geojsonList
        });
        this.jsonfillcolor = this.geojsonList;
      }
      // 多个行政区域时 触发
      console.log(`this.geojsonList`, this.geojsonList);
      if (this.jsonfillcolor.length > 1 && this.jsonfillcolor.length === this.geojsonList.length) {
        let isEqual = this.jsonfillcolor.length === this.geojsonList.length && this.jsonfillcolor.every((value, index) => JSON.stringify(value) === JSON.stringify(this.geojsonList[index]));
        console.log(`isEqual`, isEqual);
        if (isEqual) this.SET_MAPFORMITEM({
          fillcolorIndex: this.jsonfillcolor.length + 1
        });
      }
      if (this.mapv2info.form.mapmodetype === '静态地图') return;
      if (this.mapv2info.form.filltype === '纯色填充') evt.target.getFeatures().forEach(feature => {
        this.setJsonfeaturefillcolor(feature, 0);
      });
      if (this.mapv2info.form.filltype === '填充图片' && this.geojsonList.length > 1) {
        const mergedData = this.geoJsonUnion(this.jsonSource.getFeatures());
        this.jsonSource = new VectorSource({
          features: [mergedData]
        });
        this.jsonLayer.setSource(this.jsonSource);
      }
    },
    gethoverLayer() {
      return new LayerImage({
        source: this.setSourceImagestatic(this.hoverImg, []),
        opacity: 1,
        className: 'hoverimg',
        zIndex: 5
      });
    },
    /**
     * 绘制图层
     */
    getDrawLayer() {
      this.drawSource = new VectorSource();
      // 非遗地图移动端不显示绘制图层
      if (Object.keys(this.drawelement).length > 0 && this.drawelement.drawJson) {
        let data = this.drawelement;
        const featureJson = new GeoJSON().readFeatures(data.drawJson);
        featureJson.forEach((feature, index) => {
          if (feature.get('name')) {
            let textstyle = feature.get('style');
            let name = feature.get('name');
            if (textstyle.align === 0) {
              name = name.replace(/\uff08/g, '\ufe35');
              name = name.replace(/\uff09/g, '\ufe36');
              name = name.split('').join('\n');
            } else {
              name = name.replace(/\ufe35/g, '\uff08');
              name = name.replace(/\ufe36/g, '\uff09');
            }
            feature.setStyle(new Style({
              text: new StyleText({
                text: name,
                font: `${textstyle.fontSize}px FZShengShiKaiShuS-DB-GB`,
                textBaseline: 'top',
                textAlign: 'left',
                fill: new StyleFill({
                  color: textstyle.color
                })
              })
            }));
          }
          if (feature.getGeometry().getType() === 'LineString') {
            let linestyle = Object.keys(data.linestyle).length > 0 ? data.linestyle : this.drawstyle;
            feature.setStyle(new Style({
              stroke: new StyleStroke(linestyle)
            }));
          }
          if (feature.getGeometry().getType() === 'GeometryCollection' && feature.get('type') === 'circle') {
            let linestyle = Object.keys(data.linestyle).length > 0 ? data.linestyle : this.drawstyle;
            feature = new Feature({
              geometry: new Circle(feature.get('coordinate'), this.CircleRadius),
              type: 'circle',
              coordinate: feature.get('coordinate')
            });
            feature.setStyle(new Style({
              fill: new StyleFill({
                color: linestyle.color
              }),
              stroke: new StyleStroke({
                color: linestyle.color,
                width: this.CircleRadius
              })
            }));
          }
          this.drawSource.addFeature(feature);
        });
        if (Object.keys(data.linestyle).length > 0) {
          this.drawstyle = data.linestyle;
        }
      }
      return new VectorLayer({
        source: this.drawSource,
        className: 'draw',
        style: new Style({
          stroke: new StyleStroke(this.drawstyle)
        }),
        zIndex: 9
      });
    },
    drawSourceChange(evt) {
      let that = this;
      evt.target.getFeatures().forEach(feature => {
        if (feature.get('dindex') !== undefined) {
          let arrCoordinates = feature.getGeometry().getCoordinates();
          let defaultValue = [...arrCoordinates];
          let coordinates = [];
          // 两点 判断起始点 确定方向 绘制直角直线
          if (arrCoordinates.length === 2) {
            coordinates.push(defaultValue[0]);
            coordinates.push(that.getcurrentCoordinates(defaultValue[0], defaultValue[1]));
          }
          if (arrCoordinates.length > 2) {
            function setCoordinatesArr(i) {
              if (i === 0) {
                coordinates.push(defaultValue[i]);
                setCoordinatesArr(i + 1);
              } else if (i > defaultValue.length - 1) {
                return;
              } else {
                let nextC = that.getcurrentCoordinates(coordinates[i - 1], defaultValue[i]);
                coordinates.push(nextC);
                setCoordinatesArr(i + 1);
              }
            }
            setCoordinatesArr(0);
          }
          let features = [];
          // 创建直角线段的几何对象
          const geometry = new LineString(coordinates);

          // 创建具有直角线段几何对象的特性
          const linefeature = new Feature({
            geometry: geometry,
            findex: feature.get('dindex')
          });

          // 设置线的样式
          linefeature.setStyle(new Style({
            stroke: new StyleStroke(this.drawstyle)
          }));
          let lineStart = coordinates[0];
          let lineEnd = coordinates[coordinates.length - 1];
          let startCircleGeom = new Circle(lineStart, this.CircleRadius);
          let endCircleGeom = new Circle(lineEnd, this.CircleRadius);
          const circleitemStyle = new Style({
            fill: new StyleFill({
              color: this.drawstyle.color
            }),
            stroke: new StyleStroke({
              color: this.drawstyle.color,
              width: this.CircleRadius
            })
          });
          let startfeature = new Feature({
            geometry: startCircleGeom,
            type: 'circle',
            coordinate: lineStart
          });
          startfeature.setStyle(circleitemStyle);
          let endfeature = new Feature({
            geometry: endCircleGeom,
            type: 'circle',
            coordinate: lineEnd
          });
          endfeature.setStyle(circleitemStyle);
          features = [linefeature, startfeature, endfeature];
          this.drawSource.removeFeature(feature);
          this.drawSource.addFeatures(features);
        }
      });
    },
    /**
     * 更新地图
     */
    updateMap() {
      this.$nextTick(() => {
        console.log('更新地图');
        this.map.getView().setCenter(transform(this.center, 'EPSG:4326', 'EPSG:3857'));
        this.map.getView().setMinZoom(this.minZoom);
        this.map.getView().setMaxZoom(this.maxZoom);
        this.map.getView().setZoom(this.zoom);
        this.map.getView().setRotation(this.rotation);
        if (this.editmap !== '') {
          this.editmap.getView().setCenter(transform(this.center, 'EPSG:4326', 'EPSG:3857'));
          this.editmap.getView().setMinZoom(this.minZoom);
          this.editmap.getView().setMaxZoom(this.maxZoom);
          this.editmap.getView().setZoom(this.zoom);
          this.editmap.getView().setRotation(this.rotation);
        }
      });
    },
    isVisiblePoint(elem) {
      if (!elem || !elem.itemformdata || !elem.itemformdata.map_coordinates) return false;
      return elem.itemformdata[34] !== '隐藏';
    },
    syncPointFeatures(val) {
      const list = Array.isArray(val) ? val : [];
      const nextPointIds = new Set();
      const toCreate = [];
      list.forEach(elem => {
        if (!this.isVisiblePoint(elem)) return;
        nextPointIds.add(elem.id);
        if (!this.lastPointIds.has(elem.id)) toCreate.push(elem);
      });
      if (toCreate.length > 0) this.createPoint(toCreate);
      this.lastPointIds.forEach(pointId => {
        if (nextPointIds.has(pointId)) return;
        const features = this.iconSource.getFeatures().filter(feature => {
          return feature.get('id') === pointId && feature.get('score') === 0;
        });
        features.forEach(feature => {
          this.iconSource.removeFeature(feature);
        });
      });
      this.lastPointIds = nextPointIds;
    },
    /**
     * 单击地图操作
     */
    singleclick(val) {
      console.log(`val`, val);
      // 高德坐标
      let coordinateArr = transform(val.coordinate, 'EPSG:3857', 'EPSG:4326');

      // 绘制线段 禁止单击
      if (this.drawflag) return;
      // 绘制文字操作
      if (this.drawtextflag) {
        this.drawtextsingleflag = true;
        this.helpTooltipElement.innerHTML === '';
        this.helpTooltipElement.classList.add('hidden');
        if (this.drawtextsingleflag) {
          this.SET_MAPDRAWLAYERITEM({
            showtranfer: true
          });
          this.SET_MAPDRAWLAYERITEM({
            currentCoordinate: coordinateArr
          });
          return;
        }
      }
      console.log('coordinate: ' + coordinateArr[0].toFixed(6) + ',' + coordinateArr[1].toFixed(6));
      let bdpoint = gaoDeToBaidu(coordinateArr[0].toFixed(6), coordinateArr[1].toFixed(6));
      this.$emit('singleclick', `${bdpoint.lng.toFixed(6)}, ${bdpoint.lat.toFixed(6)}`);
    },
    /**
     * 创建地图点位
    * @param {Array} val 点位数据
     */
    createPoint(val) {
      if (val.length === 0) return;
      this.timers = [];
      let that = this;
      for (let i = 0; i < val.length; i++) {
        const elem = val[i];
        const item = val[i].itemformdata;
        // 兼容点位隐藏字段
        if (!this.isVisiblePoint(elem)) continue;
        const c = item.map_coordinates.split(',');
        const gd = bd_decrypt(Number(c[0]), Number(c[1]));
        const x = Number(gd.lng);
        const y = Number(gd.lat);
        let obj = {
          name: item.place_name,
          image: item[4].length > 0 ? getImg(item[4][0]) : this.defaulticon,
          icon: item.icon !== undefined ? item.icon : this.defaulticon,
          zIndex: item.zIndex !== undefined ? item.zIndex : 1
        };
        const isHasSeniorset = item.hasOwnProperty('seniorset');
        let seniorsetData = null;
        if (isHasSeniorset && item.seniorset !== '' && item.seniorset !== undefined) {
          seniorsetData = item.seniorset;
          // 兼容旧数据：如果根上有 text/pic 等字段，说明是旧格式，视为 pc 端数据
          if (seniorsetData.text !== undefined || seniorsetData.pic !== undefined) {
            seniorsetData = {
              pc: seniorsetData
            };
          }
        }
        // 根据当前平台获取对应数据
        const platformKey = this.isMobile ? 'app' : 'pc';
        const platformSeniorset = seniorsetData && seniorsetData[platformKey] ? seniorsetData[platformKey] : null;
        const isStyleFollow = !platformSeniorset || platformSeniorset.isFollowglobal;
        if (!isStyleFollow) {
          const singleObj = {
            spic: platformSeniorset.pic !== undefined && platformSeniorset.pic.scale !== undefined ? platformSeniorset.pic : this.style.pointpic,
            stext: platformSeniorset.text !== undefined && platformSeniorset.text.limit !== undefined ? platformSeniorset.text : this.style.pointtext,
            sicon: platformSeniorset.icon !== undefined && platformSeniorset.icon.scale !== undefined ? platformSeniorset.icon : this.style.pointicon,
            pointStyleIndex: platformSeniorset.pointStyleIndex !== undefined ? platformSeniorset.pointStyleIndex : this.style.pointStyleIndex,
            isFollowglobal: false
          };
          obj = Object.assign(obj, singleObj);
        }
        let pointfeature = new Feature({
          geometry: new Point(fromLonLat([x, y])),
          id: elem.id,
          ...obj,
          xy: [x, y],
          score: 0
        });

        // 处理gif图片
        if (item[4].length > 0 && item[4][0].suffix === 'gif') {
          obj.gif = getImg(item[4][0]);
          // 为当前迭代创建独立定时器，并存入数组
          const timer = setInterval(() => {
            if (gifler) {
              const gifUrl = getImg(item[4][0]);
              const gif = gifler(gifUrl);
              gif.frames(document.createElement('canvas'), function (ctx, frame) {
                if (!pointfeature.getStyle()) {
                  pointfeature.setStyle(that.getStyle(obj, isStyleFollow ? that.style.pointStyleIndex : obj.pointStyleIndex, ctx, frame, isStyleFollow ? {} : obj));
                }
                ctx.clearRect(0, 0, frame.width, frame.height);
                ctx.drawImage(frame.buffer, frame.x, frame.y);
                that.map.render();
              }, true);
              // 清除当前定时器（使用局部变量timer）
              clearInterval(timer);
              // 从数组中移除当前定时器
              const index = that.timers.indexOf(timer);
              if (index !== -1) {
                that.timers.splice(index, 1);
              }
            }
          }, 100);
          // 将当前定时器存入数组
          this.timers.push(timer);
        } else {
          // 处理非gif图片
          pointfeature.setStyle(this.getStyle(obj, isStyleFollow ? this.style.pointStyleIndex : obj.pointStyleIndex, false, false, isStyleFollow ? {} : obj));
        }
        this.iconSource.addFeature(pointfeature);
      }
    },
    /**
     * 设置相应样式
     * @param {Object} singleOptions 单个点位样式
     */
    getStyle(item, sIndex, ctx, frame, singleOptions = {}) {
      let Styles = [];
      let stext = singleOptions.hasOwnProperty('stext') ? singleOptions.stext : this.style.pointtext;
      let spic = singleOptions.hasOwnProperty('spic') ? singleOptions.spic : this.style.pointpic;
      let sicon = singleOptions.hasOwnProperty('sicon') ? singleOptions.sicon : this.style.pointicon;

      // 绘制圆角矩形
      let textsize = parseInt(stext.fontSize);
      let canvas = document.createElement('canvas');
      let context = canvas.getContext('2d');
      let namelen = item.name.length + 1;
      canvas.width = namelen * textsize;
      canvas.height = textsize + 6;
      let x = 0;
      let y = 0;
      let w = canvas.width;
      let h = canvas.height;
      let r = Math.ceil((textsize + 6) / 2);
      // 缩放
      context.scale(1, 1);
      context.fillStyle = stext.fill;
      // 绘制圆角矩形
      context.beginPath();
      context.moveTo(x + r, y);
      context.arcTo(x + w, y, x + w, y + h, r);
      context.arcTo(x + w, y + h, x, y + h, r);
      context.arcTo(x, y + h, x, y, r);
      context.arcTo(x, y, x + w, y, r);
      // 设置阴影
      // context.shadowColor = 'rgba(0, 0, 0, 0.2)' // 颜色
      // context.shadowBlur = 5 // 模糊尺寸
      // context.shadowOffsetX = 2 // 阴影Y轴偏移
      // context.shadowOffsetY = 2 // 阴影X轴偏移
      // ----
      context.closePath();
      // 填充
      context.fill();
      let image = '';
      if (ctx) {
        image = new Style({
          image: new StyleIcon({
            img: ctx.canvas,
            opacity: 1,
            imgSize: [frame.width, frame.height],
            anchor: spic.anchor,
            scale: spic.scale,
            rotateWithView: true
          }),
          zIndex: item.zIndex
        });
      } else {
        image = new Style({
          image: new StyleIcon({
            src: item.image,
            anchor: spic.anchor,
            scale: spic.scale,
            rotateWithView: true
          }),
          zIndex: item.zIndex
        });
      }
      let icon = item.icon !== '' ? new Style({
        image: new StyleIcon({
          src: item.icon,
          anchor: sicon.anchor,
          scale: sicon.scale,
          rotateWithView: true
        }),
        zIndex: item.zIndex
      }) : '';
      let text = new Style({
        image: new StyleIcon({
          img: canvas,
          imgSize: [w, h],
          rotateWithView: true
        }),
        text: new StyleText({
          textAlign: 'center',
          text: item.name,
          font: `${stext.fontSize} sans-serif`,
          offsetY: 1,
          fill: new StyleFill({
            color: stext.color
          }),
          stroke: stext.stroke !== '' ? new StyleStroke({
            color: stext.stroke,
            width: 1
          }) : '',
          rotateWithView: true
        }),
        zIndex: item.zIndex
      });
      if (sIndex === 0) {
        Styles.push(image);
        Styles.push(text);
      }
      if (sIndex === 1 || sIndex === 5) Styles.push(image);
      if (sIndex === 2 || sIndex === 7) Styles.push(icon);
      if (sIndex === 3) Styles.push(text);
      if (sIndex === 4 || sIndex === 6) {
        Styles.push(icon);
        Styles.push(text);
      }
      if (sIndex === 8) {
        Styles.push(image);
        Styles.push(icon);
        Styles.push(text);
      }

      // 若zIndex大于2，则返回(image, text) 场景：标准模版 列表点击点位效果
      if (item.zIndex !== undefined && item.zIndex > 2) return [image, text];
      return Styles;
    },
    /**
     * 单击点位操作
     */
    markerclick(evt) {
      // evt.preventDefault()
      if (this.isnotclick) return;
      let feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
      });
      if (feature) feature.set('pixel', evt.pixel);
      this.$emit('markerclick', feature);
    },
    /**
     * 鼠标移入点位操作 动效
     */
    markermove(evt) {
      if (this.drawflag || this.drawtextflag) {
        if (this.deleteflag) return;
        if (this.drawtextsingleflag) return;
        if (this.drawflag) this.helpTooltipElement.innerHTML = this.drawsketch ? '点击继续绘制线，双击结束绘制' : this.drawsketch ? '拖动修改' : '点击开始绘制';
        if (this.drawtextflag) this.helpTooltipElement.innerHTML = '点击选择位置后 添加点位名称';
        this.helpTooltip.setPosition(evt.coordinate);
        this.helpTooltipElement.classList.remove('hidden');
        return;
      }
      let feature = this.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
      });
      this.$emit('markermove', feature);
      if (this.cfeature !== null) {
        const obj = this.cfeature.getProperties();
        const isHasFollow = obj.isFollowglobal === undefined || obj.isFollowglobal ? true : false;
        let sIndex = isHasFollow ? this.style.pointStyleIndex : obj.pointStyleIndex;
        if (sIndex === 5 || sIndex === 6 || sIndex === 7) {
          let normalStyle;
          if (sIndex === 5) normalStyle = this.getStyle(obj, 1, false, false, isHasFollow ? {} : obj);
          if (sIndex === 6) normalStyle = this.getStyle(obj, 6, false, false, isHasFollow ? {} : obj);
          if (sIndex === 7) normalStyle = this.getStyle(obj, 7, false, false, isHasFollow ? {} : obj);
          if (normalStyle !== undefined) normalStyle.forEach(style => {
            style.setZIndex(this.cfeature.get('zIndex'));
          });
          this.cfeature.setStyle(normalStyle);
        }
        this.cfeature = null;
      }
      this.map.getTarget().style.cursor = '';
      if (feature && feature.get('xy')) {
        this.map.getTarget().style.cursor = 'pointer';
        let cid = feature.get('id');
        let allfeatures = this.iconSource.getFeatures();
        allfeatures.forEach(item => {
          let id = item.get('id');
          const obj = item.getProperties();
          const isHasFollow = obj.isFollowglobal === undefined || obj.isFollowglobal ? true : false;
          let sIndex = isHasFollow ? this.style.pointStyleIndex : obj.pointStyleIndex;
          if (cid === id) {
            // 鼠标移入显示效果
            if (sIndex === 5 || sIndex === 6 || sIndex === 7) {
              let hoverStyle;
              if (sIndex === 5) hoverStyle = this.getStyle(obj, 0, false, false, isHasFollow ? {} : obj);
              if (sIndex === 6) hoverStyle = this.getStyle(obj, 8, false, false, isHasFollow ? {} : obj);
              if (sIndex === 7) hoverStyle = this.getStyle(obj, 8, false, false, isHasFollow ? {} : obj);
              hoverStyle.forEach(style => {
                style.setZIndex(2);
              });
              feature.setStyle(hoverStyle);
            }
            this.cfeature = feature;
          }
        });
      }
      // 虹口地图 鼠标移入显示相应地图图片【先定制后通用】
      if (feature && !feature.get('xy') && this.$route.query.fid === '222755') {
        this.map.getTarget().style.cursor = 'pointer';
        let code = Number(feature.get('code'));
        let geometry = feature.get('geometry');
        let current = this.hoverImgList.find(elem => {
          return elem.code === code;
        });
        let extent = geometry.extent_.map((item, index) => {
          if (index === 0 || index === 1) item = item - 600;
          if (index === 2 || index === 3) item = item + 600;
          return item;
        });
        this.map.getLayers().getArray().forEach(item => {
          if (item.getClassName() === 'hoverimg') {
            item.setVisible(true);
            item.setSource(this.setSourceImagestatic(current.image, extent));
          }
        });
      }
      // 恩施州 鼠标移入显示相应地图图片【先定制后通用】
      if (feature && !feature.get('xy') && this.$route.query.fid === '331112') {
        this.map.getTarget().style.cursor = 'pointer';
        let code = Number(feature.get('adcode'));
        let geometry = feature.get('geometry');
        let current = this.hoverImgList.find(elem => {
          return elem.code === code;
        });
        let extent = geometry.extent_.map((item, index) => {
          // if (index === 0 || index === 1) item = item - 600
          // if (index === 2 || index === 3) item = item + 600
          return item;
        });
        this.map.getLayers().getArray().forEach(item => {
          if (item.getClassName() === 'hoverimg') {
            item.setVisible(true);
            item.setSource(this.setSourceImagestatic(current.image, extent));
          }
        });
      }
      // 填充地图 填充地图 移入区域改变样式
      if (feature && (feature.get('adcode') || feature.get('code')) && this.mapv2info.form.mapmodetype === '填充地图' && this.mapv2info.form.filltype === '纯色填充') {
        this.map.getTarget().style.cursor = 'pointer';
        // 区分地图投影feature
        if (feature.get('shadow') !== undefined) return;
        this.jsonSource.getFeatures().forEach((feature, index) => {
          this.setJsonfeaturefillcolor(feature, 0);
        });
        this.setJsonfeaturefillcolor(feature, 1);
      }
      if (feature === undefined) {
        this.map.getLayers().getArray().forEach(item => {
          if (item.getClassName() === 'hoverimg') item.setVisible(false);
        });
        if (this.mapv2info.form.mapmodetype === '填充地图' && this.mapv2info.form.filltype === '纯色填充') {
          this.jsonSource.getFeatures().forEach((feature, index) => {
            this.setJsonfeaturefillcolor(feature, 0);
          });
        }
      }
    },
    /**
     * 地图移动结束操作
     */
    markermoveend(evt) {
      let zoom = Math.round(this.map.getView().getZoom());
      if (this.defaultZoom === zoom && this.moveendflag) return false;
      if (this.defaultZoom !== zoom) this.defaultZoom = zoom;
      this.$emit('markermoveend', zoom);
    },
    changeToolHandle(val) {
      if (val !== '') this.isnotclick = true;
      if (val === 0 || val === 6) {
        this.deleteflag = false;
        this.createHelpTooltip();
        if (val === 0) this.showtexthelp();
      } else {
        if (this.helpTooltipElement) {
          this.helpTooltipElement.innerHTML === '';
          this.helpTooltipElement.classList.add('hidden');
        }
      }
      this.drawtextflag = val === 0 ? true : false;
      this.drawflag = val === 6 ? true : false;
      val === 6 ? this.addDrawInteractions() : this.removedrawInteractions();
      if (val === 2) {
        this.deleteflag = true;
        this.deleteDrawInteractions();
      }
      if (val === 3) {
        this.addselectInteraction();
        this.adddragboxInteraction();
      }
      if (val === 4) this.addtranslateInteraction();
    },
    /**
     * 地图添加 draw snap modify 交互效果
     */
    addDrawInteractions() {
      let that = this;
      this.drawinter = new Draw({
        source: this.drawSource,
        type: 'LineString',
        style: this.addStyle()
      });
      this.drawinter.on('drawstart', evt => {
        this.drawsketch = evt.feature;
        let sketch = evt.feature;
        sketch.set('dindex', this.findex);
        this.findex++;
      });
      this.drawinter.on('drawend', evt => {
        this.drawsketch = null;
      });
      this.map.addInteraction(this.drawinter);
      this.modifyinter = new Modify({
        source: this.drawSource,
        style: this.addStyle()
      });
      this.map.addInteraction(this.modifyinter);
      this.snapinter = new Snap({
        source: this.drawSource
      });
      this.map.addInteraction(this.snapinter);
      this.snapinter.on('snap', event => {
        this.helpTooltipElement.innerHTML = '拖动修改';
      });
    },
    getcurrentCoordinates(a1, a2) {
      let x1 = a1[0];
      let y1 = a1[1];
      let x2 = a2[0];
      let y2 = a2[1];
      let newCoordinate = [];
      if (x2 - x1 >= 0 && y2 - y1 >= 0 || x2 - x1 >= 0 && y2 - y1 <= 0 || x2 - x1 <= 0 && y2 - y1 >= 0 || x2 - x1 <= 0 && y2 - y1 <= 0) {
        if (Math.abs(x2 - x1) > Math.abs(y2 - y1)) {
          newCoordinate = [x2, y1];
        } else {
          newCoordinate = [x1, y2];
        }
      }
      return newCoordinate;
    },
    addStyle() {
      return new Style({
        stroke: new StyleStroke({
          color: '#2B67FF',
          width: 2
        }),
        image: new StyleCircle({
          radius: 5,
          fill: new StyleFill({
            color: '#2B67FF'
          })
        })
      });
    },
    /**
     * 地图移出 draw snap modify 交互效果
     */
    removedrawInteractions() {
      this.map.removeInteraction(this.modifyinter);
      this.modifyinter = '';
      this.map.removeInteraction(this.drawinter);
      this.drawinter = '';
      this.map.removeInteraction(this.snapinter);
      this.snapinter = '';
      this.map.removeInteraction(this.selectinter);
      this.selectinter = '';
      this.map.removeInteraction(this.dragboxinter);
      this.dragboxinter = '';
      this.map.removeInteraction(this.translateinter);
      this.translateinter = '';
    },
    /**
     * 创建提示信息
     */
    createHelpTooltip() {
      if (this.helpTooltipElement) this.helpTooltipElement.parentNode.removeChild(this.helpTooltipElement);
      this.helpTooltipElement = document.createElement('div');
      this.helpTooltipElement.className = 'ol-tooltip hidden';
      this.helpTooltip = new Overlay({
        element: this.helpTooltipElement,
        offset: [15, 0],
        positioning: 'center-left'
      });
      this.map.addOverlay(this.helpTooltip);
    },
    /**
     * 绘制删除操作
     */
    deleteDrawInteractions() {
      if (this.selectedFeatures.length === 0) {
        ElMessage({
          message: '请先选择要删除的绘制元素',
          type: 'warning'
        });
        return;
      }
      let deletedata = [];
      ElMessageBox.confirm('确定要删除么？', '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.selectedFeatures.getArray().forEach(feature => {
          if (feature.get('name')) deletedata.push({
            key: feature.get('id'),
            label: feature.get('name')
          });
          this.SET_MAPDRAWLAYERITEM({
            deleteList: deletedata
          });
          this.drawSource.removeFeature(feature);
        });
      }).catch(() => {
        this.selectedFeatures.clear();
      });
    },
    /**
     * 选择绘制元素
     */
    addselectInteraction() {
      this.selectinter = new Select({
        style: feature => {
          let featuretype = feature.getGeometry().getType();
          if (featuretype !== 'LineString' && featuretype !== 'Point' && featuretype !== 'Circle') return;
          let textstyle = this.currentTextstyle;
          if (feature.get('name')) textstyle = feature.get('style');
          return new Style({
            fill: new StyleFill({
              color: '#2B67FF'
            }),
            stroke: new StyleStroke({
              color: '#2B67FF',
              width: feature.get('type') === 'circle' ? this.CircleRadius : 2
            }),
            text: feature.get('name') ? new StyleText({
              text: textstyle.align === 0 ? feature.get('name').split('').join('\n') : feature.get('name'),
              font: `${textstyle.fontSize}px FZShengShiKaiShuS-DB-GB`,
              textBaseline: 'top',
              textAlign: 'left',
              fill: new StyleFill({
                color: '#2B67FF'
              })
            }) : ''
          });
        }
      });
      this.map.addInteraction(this.selectinter);
      this.selectedFeatures = this.selectinter.getFeatures();
    },
    /**
     * 框选绘制元素
     */
    adddragboxInteraction() {
      this.dragboxinter = new DragBox({
        condition: platformModifierKeyOnly
      });
      this.dragboxinter.on('boxstart', () => {
        this.selectedFeatures.clear();
      });
      this.dragboxinter.on('boxend', () => {
        const boxExtent = this.dragboxinter.getGeometry().getExtent();
        const worldExtent = this.map.getView().getProjection().getExtent();
        const worldWidth = getWidth(worldExtent);
        const startWorld = Math.floor((boxExtent[0] - worldExtent[0]) / worldWidth);
        const endWorld = Math.floor((boxExtent[2] - worldExtent[0]) / worldWidth);
        for (let world = startWorld; world <= endWorld; ++world) {
          const left = Math.max(boxExtent[0] - world * worldWidth, worldExtent[0]);
          const right = Math.min(boxExtent[2] - world * worldWidth, worldExtent[2]);
          const extent = [left, boxExtent[1], right, boxExtent[3]];
          const boxFeatures = this.drawSource.getFeaturesInExtent(extent).filter(feature => !this.selectedFeatures.getArray().includes(feature) && feature.getGeometry().intersectsExtent(extent));
          const rotation = this.map.getView().getRotation();
          const oblique = rotation % (Math.PI / 2) !== 0;
          if (oblique) {
            const anchor = [0, 0];
            const geometry = this.dragboxinter.getGeometry().clone();
            geometry.translate(-world * worldWidth, 0);
            geometry.rotate(-rotation, anchor);
            const extent = geometry.getExtent();
            boxFeatures.forEach(function (feature) {
              const geometry = feature.getGeometry().clone();
              geometry.rotate(-rotation, anchor);
              if (geometry.intersectsExtent(extent)) {
                this.selectedFeatures.push(feature);
              }
            });
          } else {
            this.selectedFeatures.extend(boxFeatures);
          }
        }
        let that = this;
      });
      this.map.addInteraction(this.dragboxinter);
    },
    /**
     * 平移绘制元素
     */
    addtranslateInteraction() {
      if (this.selectedFeatures.length === 0) {
        ElMessage({
          message: '请先选择要平移的绘制元素',
          type: 'warning'
        });
        return;
      }
      this.translateinter = new Translate({
        features: this.selectedFeatures
      });
      this.map.addInteraction(this.translateinter);
    },
    /**
     * 绘制文字
     */
    createText(val, name) {
      console.log(`绘制文字`, val);
      this.drawSource.getFeatures().forEach(feature => {
        if (feature.get('type') === 0) this.drawSource.removeFeature(feature);
      });
      let data = this.mapv2info.drawlayer;
      let iconFeatures = [];
      let list = name === 'currentList' ? val : data.currentList;
      list.forEach((elem, index) => {
        let coordinate = [...data.currentCoordinate];
        let cstyle = {
          ...this.currentTextstyle
        };
        cstyle.color = (index - 1) % 3 === 0 ? cstyle.color2 : cstyle.color1;
        let space = cstyle.fontSpace ? cstyle.fontSpace : 4;
        if (cstyle.align === 0) coordinate[0] = coordinate[0] + index * (cstyle.fontSize * space * 0.001);
        if (cstyle.align === 1) coordinate[1] = coordinate[1] - index * (cstyle.fontSize * space * 0.001);
        let feature = new Feature({
          geometry: new Point(transform(coordinate, 'EPSG:4326', 'EPSG:3857')),
          id: elem.key,
          name: elem.label,
          type: name === 'currentList' ? 0 : val,
          style: cstyle
        });
        let text = elem.label;
        if (cstyle.align === 0) {
          elem.label = elem.label.replace(/\uff08/g, '\ufe35');
          elem.label = elem.label.replace(/\uff09/g, '\ufe36');
          text = elem.label.split('').join('\n');
        }
        feature.setStyle(new Style({
          text: new StyleText({
            text: text,
            font: `${cstyle.fontSize}px FZShengShiKaiShuS-DB-GB`,
            textBaseline: 'top',
            textAlign: 'left',
            fill: new StyleFill({
              color: cstyle.color
            })
          })
        }));
        iconFeatures.push(feature);
      });
      this.drawSource.addFeatures(iconFeatures);
      if (name === 'drawtextblocksum') {
        this.SET_MAPDRAWLAYERITEM({
          currentList: []
        });
        this.showtexthelp();
      }
    },
    showtexthelp() {
      this.drawtextsingleflag = false;
      this.helpTooltipElement.innerHTML = '点击选择位置后 添加点位名称';
      this.helpTooltipElement.classList.remove('hidden');
    },
    /**
     * 保存绘制数据
     */
    saveDrawHandle() {
      let feature = this.drawSource.getFeatures();
      let jsonObj = new GeoJSON().writeFeatures(feature);
      this.SET_MAPDRAWLAYERITEM({
        drawJson: feature.length > 0 ? jsonObj : ''
      });
    },
    /**
     * 创建非遗数据点位
     */
    createculturalPoint(val) {
      if (val.length === 0) return;
      let zoom = Math.round(this.map.getView().getZoom());
      let diffscale = zoom - this.minZoom;
      let showArr = val.filter(item => {
        return item.itemformdata.correlation_map === '是' && item.itemformdata.correlation_address.length > 0;
      });
      showArr.forEach(elem => {
        let item = elem.itemformdata;
        // 有坐标的显示
        let gd = bd_decrypt(Number(item.correlation_address[0].lng), Number(item.correlation_address[0].lat));
        let x = Number(gd.lng);
        let y = Number(gd.lat);
        let obj = {
          name: item.title,
          image: item.icon ? item.icon : this.defaulticon,
          icon: ''
        };
        let pointfeature = new Feature({
          geometry: new Point(fromLonLat([x, y])),
          id: elem.id,
          name: obj.name,
          image: obj.image,
          icon: '',
          xy: [x, y],
          score: 1
        });
        pointfeature.setStyle(this.getStyle(obj, 1));
        let scale = pointfeature.getStyle()[0].getImage().getScale();
        pointfeature.getStyle()[0].getImage().setScale(diffscale * 0.2 + scale);
        this.iconSource.addFeature(pointfeature);
      });
      // 龙岩地图添加 随机显示 gif动图 20240529 后面可以在高级设置的 交互效果 做统一对接 移动端不显示闪烁点 页面会一直重复加载
      if (this.$route.query.fid === '138053' && !this.isMobile) {
        this.setpointlight(showArr);
      }
    },
    setpointlight(arr) {
      let that = this;
      let len = arr.length;
      let max = len / 3;
      let newIndexArr = [];
      for (let i = 0; i < 6; i++) {
        let randIndex = Math.floor(Math.random() * len);
        if (!newIndexArr.includes(randIndex)) newIndexArr.push(randIndex);
      }
      newIndexArr.forEach(elem => {
        let item = arr[elem].itemformdata;
        // 有坐标的显示
        let gd = bd_decrypt(Number(item.correlation_address[0].lng), Number(item.correlation_address[0].lat));
        let x = Number(gd.lng);
        let y = Number(gd.lat);
        let obj = {
          name: item.title,
          image: this.lightIcon[Math.floor(Math.random() * 3)],
          icon: '',
          gif: this.lightIcon[Math.floor(Math.random() * 3)]
        };
        let pointfeature = new Feature({
          geometry: new Point(fromLonLat([x, y])),
          id: arr[elem].id,
          name: obj.name,
          image: obj.image,
          icon: '',
          xy: [x, y],
          score: 1,
          light: true
        });
        const gifUrl = obj.gif;
        const gif = gifler(gifUrl);
        gif.frames(document.createElement('canvas'), function (ctx, frame) {
          if (!pointfeature.getStyle()) {
            pointfeature.setStyle(new Style({
              image: new StyleIcon({
                img: ctx.canvas,
                opacity: 1,
                imgSize: [frame.width, frame.height],
                anchor: [0.5, 0.5],
                scale: 0.02
              })
            }));
          }
          ctx.clearRect(0, 0, frame.width, frame.height);
          ctx.drawImage(frame.buffer, frame.x, frame.y);
          that.map.render();
        }, true);
        this.iconSource.addFeature(pointfeature);
      });
    },
    addpopOverLay(coordinate) {
      const container = document.querySelector('.popcontainer-style1');
      this.overlay = new Overlay({
        element: container,
        positioning: 'bottom-left'
      });
      this.overlay.setPosition(fromLonLat(coordinate));
      this.map.addOverlay(this.overlay);
    },
    removeAlliconsource() {
      this.iconSource.clear();
    },
    removeDrawsource() {
      this.drawSource.clear();
    },
    removeRoutesource() {
      this.routeSource.clear();
      this.routeLayer.un('postrender', this.moveFeature);
    },
    createRoute(val, flag) {
      console.log(`createRoute`, val);
      if (val.length === 0) return;
      this.routeSource.clear();
      let routeFeatures = [];
      this.allpath = [];
      this.currentPath = {};
      this.pathIndex = 0;
      this.routeData = _.cloneDeep(val);
      val.forEach((item, index) => {
        let linestyle = {
          ...item.style
        };
        if (linestyle.lineDash) {
          linestyle.lineDash.length > 0 ? linestyle.lineDash = linestyle.lineDash.map(item => {
            return linestyle.width * item;
          }) : delete linestyle.lineDash;
        }
        if (index === 0) this.routeStyle = linestyle;
        const valSpeed = val[index].speed;
        item.path.forEach((child, cdi) => {
          let gemoetry = new LineString(child);
          // 曲线判定
          if (item.routelinetype === 3 && child.length > 2) {
            // 去掉首尾坐标
            this.curverouteCoords[cdi] = child.slice(1, -1);
            gemoetry = new LineString(createBezierCurvePoints(child.length - 1, child));
          }
          let routeFeature = new Feature({
            id: item.id ? item.id : cdi,
            type: 'allroute',
            geometry: gemoetry
          });
          routeFeature.setStyle(new Style({
            stroke: new StyleStroke(linestyle)
          }));
          routeFeatures.push(routeFeature);
          if (flag && flag !== undefined) {
            let itemcoords = gemoetry.getCoordinates();
            if (gemoetry.getCoordinates().length === 2) itemcoords = getPointsBetweenLatLong(itemcoords[0][1], itemcoords[0][0], itemcoords[1][1], itemcoords[1][0], 100);
            const speed = itemcoords.length / (valSpeed === undefined ? 4 : valSpeed[cdi]);
            this.allpath.push({
              speed: speed,
              data: [...itemcoords]
            });
          }
        });
      });
      console.log(`this.allpath`, this.allpath);
      this.saveCurverouteCoords(false);
      this.routeSource.addFeatures(routeFeatures);

      // 若线段的类型 是曲线且配置页打开时 开启绘制曲线功能
      if (val[0].isCurve) {
        console.log(`开启绘制曲线功能`);
        this.addCurveselectInteraction();
      }
      // 若默认显示全部的情况下 不出现图标轨迹动画
      if (flag && flag !== undefined) this.startMove(this.pathIndex);
      // 移动端显示路线后 路线的初始经纬度挪到地图的中心点 防止看不到
      if (this.isMobile && val.length === 1) this.map.getView().animate({
        center: val[0].path[0][0]
      });
    },
    startMove(index) {
      // 默认选择第一条路径（可根据需求调整）
      const currentPath = this.allpath[index];
      const startPoint = currentPath.data[index]; // 路径的起点坐标

      this.geoMarker = new Feature({
        type: 'geoMarker',
        geometry: new Point(startPoint)
      });
      this.geoMarker.setStyle(new Style({
        // 设置标记样式
        image: new StyleIcon({
          anchor: [0.5, 1],
          // 偏移位置
          src: this.moveicon,
          rotateWithView: true,
          opacity: 0
        })
      }));
      this.routeSource.addFeature(this.geoMarker);
      this.nowDate = new Date().getTime();
      this.animating = true;

      // 存储当前路径的 speed 和 data
      this.currentPath = currentPath;
      this.routeLayer.on('postrender', this.moveFeature);
      this.map.render();
    },
    moveFeature(event) {
      let vectorContext = olRender.getVectorContext(event);
      let frameState = event.frameState;
      if (this.animating) {
        let elapsedTime = frameState.time - this.nowDate;
        const speed = this.currentPath.speed; // 使用当前路径的速度
        const pathData = this.currentPath.data; // 当前路径的坐标数组

        let index = Math.round(speed * elapsedTime / 1000);
        // 进度条
        this.moveprogress = Math.floor(100 / pathData.length * (speed * elapsedTime) / 1000);
        if (index >= pathData.length) {
          this.moveprogress = '100';
          // this.stopMove(true)
          this.pathIndex += 1;
          this.switchPath(this.pathIndex);
          return;
        }
        let currentPoint = new Point(pathData[index]);
        let feature = new Feature(currentPoint);
        vectorContext.drawFeature(feature, new Style({
          // 设置标记样式
          image: new StyleIcon({
            anchor: [0.5, 1],
            // 偏移位置
            src: this.moveicon,
            rotateWithView: true
          })
        }));
      }
      // tell OpenLayers to continue the postrender animation
      this.map.render();
    },
    switchPath(pathIndex) {
      if (pathIndex >= 0 && pathIndex < this.allpath.length) {
        this.stopMove(false); // 停止当前动画（不重置状态）
        this.currentPath = this.allpath[pathIndex]; // 更新当前路径
        this.startMove(pathIndex); // 重新开始动画
      } else {
        this.stopMove(true);
      }
    },
    stopMove(ended) {
      const pathData = this.currentPath.data; // 当前路径的坐标数组
      this.animating = false;
      if (ended) {
        this.moveprogress = 0;
        this.nowDate = null;
      }
      let coord = ended ? pathData[pathData.length - 1] : pathData[0];
      this.geoMarker.getGeometry().setCoordinates(coord);
      //remove listener
      this.routeLayer.un('postrender', this.moveFeature); // 删除侦听器
    },
    loadLocation(val) {
      this.locationSource.clear();
      if (Object.keys(val).length > 0 && val.lng && val.lat) {
        let gd = bd_decrypt(val.lng, val.lat);
        let feature = new Feature({
          geometry: new Point(fromLonLat([gd.lng, gd.lat])),
          id: 1,
          type: 'location'
        });
        feature.setStyle(new Style({
          image: new StyleIcon({
            src: this.locationicon,
            anchor: [0.5, 0.5],
            scale: 0.7,
            rotateWithView: true
          })
        }));
        this.locationSource.addFeature(feature);
      }
    },
    /**
     * 路线曲线 选择绘制元素
     */
    addCurveselectInteraction() {
      let that = this;
      this.map.getInteractions().getArray().forEach(interaction => {
        if (interaction instanceof Select) this.map.removeInteraction(interaction);
      });
      this.selectinter = new Select({
        layers: [this.routeLayer],
        condition: click,
        style: feature => {
          let featuretype = feature.getGeometry().getType();
          if (featuretype !== 'LineString' && featuretype !== 'Point' && featuretype !== 'Circle') return;
          return new Style({
            stroke: new StyleStroke({
              lineDash: [3, 6],
              color: 'rgba(0, 0, 255, 1)',
              width: 3
            })
          });
        }
      });
      this.map.addInteraction(this.selectinter);
      this.selectinter.on('select', function (evt) {
        // console.log('select');
        // console.log(evt);
        // console.log(`that.routeData`, that.routeData);
        // console.log(`that.selectIndex`, that.selectIndex);
        // console.log(`that.routeStyle`, that.routeStyle);

        // 选择后未点击取消或确定按钮 触发事件
        if (that.toolswrap !== null && that.toolswrap !== undefined && that.selectIndex !== '') {
          that.routeSource.getFeatures().forEach(feature => {
            if (evt.selected.length > 0 && feature.get('id') === evt.selected[0].get('id')) feature.setStyle(new Style({
              stroke: new StyleStroke(that.routeStyle)
            }));
            if (feature.get('id') === that.selectIndex) that.selectinter.getFeatures().push(feature);
          });
          return;
        }
        if (that.selectinter.getFeatures().getArray().length === 0) {
          that.removeCurveModify();
          that.saveCurverouteCoords(false);
        } else {
          // 判断曲线下path 个数 若个数大于2 代表曲线
          that.modifySource = new VectorSource();
          let fIndex = evt.selected[0].get('id');
          if (that.routeData[0].path[fIndex].length > 2) {
            that.selectIndex = fIndex;
            let spath = that.routeData[0].path[fIndex];
            let scurvepath = createBezierCurvePoints(spath.length - 1, spath);
            evt.selected[0].setGeometry(new LineString(spath));
            that.modifySource.addFeature(evt.selected[0]);
            let curveFeature = new Feature({
              id: 999,
              type: 'curve',
              geometry: new LineString(scurvepath)
            });
            curveFeature.setStyle(new Style({
              stroke: new StyleStroke(that.routeStyle)
            }));
            that.routeSource.addFeature(curveFeature);
            let extent = evt.selected[0].getGeometry().getExtent();
            let toolswrapDom = document.getElementById('toolswrap');
            toolswrapDom.classList.add('show', 'curve');
            that.toolswrap = new Overlay({
              position: [extent[2], extent[3]],
              element: document.getElementById('toolswrap')
            });
            that.map.addOverlay(that.toolswrap);
          } else {
            that.modifySource.addFeature(that.selectinter.getFeatures().getArray()[0]);
          }
          that.addCurvemodifyInteraction();
          that.saveCurverouteCoords(true);
        }
      });
    },
    /**
     * 路线曲线 修改绘制元素
     */
    addCurvemodifyInteraction() {
      let that = this;
      this.modifyinter = new Modify({
        source: this.modifySource,
        style: this.addStyle()
      });
      this.map.addInteraction(this.modifyinter);
      this.modifyinter.on('modifyend', evt => {
        let select = that.selectinter.getFeatures().getArray();
        select.forEach(feature => {
          that.selectIndex = feature.get('id');
          that.selectCoords = feature.getGeometry().getCoordinates();
          let n = that.selectCoords.length - 1;
          that.selectcurveCoords = createBezierCurvePoints(n, that.selectCoords);
          let extent = feature.getGeometry().getExtent();
          let toolswrapDom = document.getElementById('toolswrap');
          toolswrapDom.classList.add('show', 'curve');
          that.toolswrap = new Overlay({
            position: [extent[2], extent[3]],
            element: document.getElementById('toolswrap')
          });
          that.map.addOverlay(that.toolswrap);
          that.routeSource.getFeatures().forEach(item => {
            if (item.get('type') === 'curve') {
              item.setGeometry(new LineString(that.selectcurveCoords));
            } else {
              let curveFeature = new Feature({
                id: 999,
                type: 'curve',
                geometry: new LineString(that.selectcurveCoords)
              });
              curveFeature.setStyle(new Style({
                stroke: new StyleStroke(that.routeStyle)
              }));
              that.routeSource.addFeature(curveFeature);
            }
          });
        });
      });
    },
    /** 移除修改交互 **/
    removeCurveModify() {
      this.modifySource = '';
      this.map.removeInteraction(this.modifyinter);
      this.modifyinter = '';
    },
    /** 曲线重置直线 **/
    resetrouteLine() {
      console.log(`this.selectIndex`, this.selectIndex);
      let coords = this.routeData[0].path.filter((item, index) => {
        return index === this.selectIndex;
      });
      let linecoords = [coords[0][0], coords[0][coords[0].length - 1]];
      this.routeData[0].path[this.selectIndex] = linecoords;
      this.resetroutefeature(linecoords);
      this.curverouteCoords[this.selectIndex] = null;
      this.saveCurverouteCoords(false);
      this.resetCurveSelectParams();
    },
    /** 曲线确认操作 **/
    confirmrouteLine() {
      let selectFeature = this.selectinter.getFeatures().getArray()[0];
      let selectFeatureIndex = selectFeature.get('id');
      let selectFeatureCoords = selectFeature.getGeometry().getCoordinates();
      console.log(`selectFeatureIndex`, selectFeatureIndex);
      console.log(`selectFeatureCoords`, selectFeatureCoords);
      this.routeData[0].path[selectFeatureIndex] = selectFeatureCoords;
      let coords = selectFeatureCoords.slice(1, -1);
      console.log(`coords`, coords);
      console.log(`this.routeData`, this.routeData);
      this.curverouteCoords[selectFeatureIndex] = coords;
      this.saveCurverouteCoords(false);
      this.resetroutefeature(this.selectcurveCoords);
      this.resetCurveSelectParams();
    },
    /** 路线曲线 重置参数及方法(公共) **/
    resetCurveSelectParams() {
      this.toolswrap.setPosition(undefined);
      this.selectinter.getFeatures().clear();
      this.removeCurveModify();
      this.selectCoords = [];
      this.selectIndex = '';
      this.selectcurveCoords = [];
      this.toolswrap = null;
    },
    resetroutefeature(coords) {
      this.routeSource.getFeatures().forEach(feature => {
        if (feature.get('id') === this.selectIndex) {
          feature.setGeometry(new LineString(coords));
          feature.setStyle(new Style({
            stroke: new StyleStroke(this.routeStyle)
          }));
        }
        if (feature.get('type') === 'curve') this.routeSource.removeFeature(feature);
      });
    },
    saveCurverouteCoords(flag) {
      this.SET_MAPROUTECURVE({
        switch: flag,
        data: this.curverouteCoords.map(item => {
          return item !== null ? item.map(child => {
            return transform(child, 'EPSG:3857', 'EPSG:4326');
          }) : item;
        })
      });
    },
    getmapPixelFromCoordinate(val) {
      console.log(`val`, val);
      let iconarr = this.iconSource.getFeatures();
      for (let index = 0; index < iconarr.length; index++) {
        const feature = iconarr[index];
        if (val.id === feature.get('id')) return this.map.getPixelFromCoordinate(feature.getGeometry().getCoordinates());
      }
    },
    removeScoreiconsource() {
      this.iconSource.getFeatures().forEach(feature => {
        if (feature.get('score') === 1) this.iconSource.removeFeature(feature);
      });
    },
    /* 地图设置 填充地图 填充颜色更改时 触发 */
    changeMapFillcolor(val) {
      console.log(val);
      if (this.mapv2info.form.mapmodetype === '静态地图') return;
      this.jsonfillcolor = _.cloneDeep(val);
      this.jsonSource.getFeatures().forEach(feature => {
        this.setJsonfeaturefillcolor(feature, 0);
      });
    },
    setJsonfeaturefillcolor(feature, index) {
      let code = feature.get('adcode') || feature.get('code');
      if (this.jsonfillcolor.length === 0) return;
      let jsonstyle = this.jsonfillcolor.find(item => {
        return Number(item.code) === Number(code);
      });
      if (jsonstyle !== undefined) {
        let style = jsonstyle.style[index];
        if (style === undefined) return;
        delete style.stroke.type;
        if (typeof style.fill === 'object') {
          // 处理渐变逻辑
          feature.setStyle(new Style({
            fill: new StyleFill({
              stroke: new StyleStroke(style.stroke),
              color: this.setGradient(feature, style.fill)
            })
          }));
        } else {
          // 处理纯色逻辑
          feature.setStyle(new Style({
            stroke: new StyleStroke(style.stroke),
            fill: new StyleFill({
              color: style.fill
            })
          }));
        }
      }
    },
    setGradient(feature, gradientcolor) {
      const extent = feature.getGeometry().getExtent();
      const tranformExtent = [...this.map.getPixelFromCoordinate([extent[0], extent[1]]), ...this.map.getPixelFromCoordinate([extent[2], extent[3]])];
      let centerX = (tranformExtent[0] + tranformExtent[2]) / 2;
      let centerY = (tranformExtent[1] + tranformExtent[3]) / 2;
      let vector = this.angleToVector(gradientcolor._angle); // yourAngle是你想要设置的角度
      let length = Math.max(tranformExtent[2] - tranformExtent[0], tranformExtent[3] - tranformExtent[1]) / 2; // 长度选择

      let startX = centerX - vector.x * length;
      let startY = centerY - vector.y * length;
      let endX = centerX + vector.x * length;
      let endY = centerY + vector.y * length;

      // const pixelRatio = ol.has.DEVICE_PIXEL_RATIO;
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      const gradient = context.createLinearGradient(startX, startY, endX, endY);
      gradientcolor._stops.forEach(stop => {
        gradient.addColorStop(stop[1], stop[0]);
      });
      return gradient;
    },
    angleToVector(angleInDegrees) {
      var angleInRadians = (angleInDegrees - 90) * Math.PI / 180; // 调整角度基准为正北
      return {
        x: Math.cos(angleInRadians),
        y: Math.sin(angleInRadians)
      };
    },
    /* 地图设置 填充地图 更改填充类型 触发 */
    changeMapfilltype(val) {
      console.log(`填充地图`, val);
      console.log(`this.mapv2info.form`, this.mapv2info.form);
      if (this.mapv2info.form.mapmodetype === '静态地图') return;
      if (val === '填充图片') {
        console.log(`this.jsonSource.getFeatures()`, this.jsonSource.getFeatures());
        if (this.geojsonList.length > 1 && this.jsonSource.getFeatures().length > 1) {
          const mergedData = this.geoJsonUnion(this.jsonSource.getFeatures());
          this.jsonSource = new VectorSource({
            features: [mergedData]
          });
          this.jsonLayer.setSource(this.jsonSource);
        }
        if (this.editmap === '') {
          this.createEditMap();
          return;
        }
        this.editMapflag = true;
        this.map.getLayers().getArray().forEach(item => {
          if (item.getClassName() === 'static') {
            item.setVisible(true);
            item.setSource(this.setSourceImagestatic(this.mapv2info.form.fillclipimage, transformExtent(this.extent, 'EPSG:4326', 'EPSG:3857')));
          }
          if (item.getClassName() === 'json') item.setOpacity(0);
        });
      }
      if (val === '纯色填充') {
        this.editMapflag = false;
        if (this.geojsonList.length > 1) {
          this.jsonSource = new VectorSource({
            features: this.defaultJsonFeatures
          });
          this.jsonLayer.setSource(this.jsonSource);
        }
        this.map.getLayers().getArray().forEach(item => {
          if (item.getClassName() === 'static') item.setVisible(false);
          if (item.getClassName() === 'json') {
            item.setOpacity(1);
            item.getSource().forEachFeature(feature => {
              this.setJsonfeaturefillcolor(feature, 0);
            });
          }
        });
      }
    },
    /* 创建填充地图 */
    createEditMap() {
      this.editMapflag = true;
      let that = this;
      let jsonExtent = this.jsonSource.getExtent();
      let jsoncenter = getCenter(jsonExtent);
      // 地图放置图片图层
      this.editiconSource = new VectorSource();
      this.editiconLayer = new VectorLayer({
        source: this.editiconSource,
        className: 'editicon',
        zIndex: 1
      });
      // 地图放置控制图片的矩形图层
      this.editpolygonSource = new VectorSource();
      this.editpolygonLayer = new VectorLayer({
        source: this.editpolygonSource,
        className: 'editpolygon',
        zIndex: 2
      });
      let polygonFeature = new Feature({
        geometry: new Polygon([this.extentToPolygonCoords(jsonExtent)]),
        type: 'dragpolygon',
        id: 1
      });
      polygonFeature.setStyle(new Style({
        stroke: new StyleStroke({
          color: 'rgba(5, 146, 232, 1)',
          width: 1,
          lineDash: [5, 2]
        }),
        fill: new StyleFill({
          color: 'rgba(0, 0, 0, 0)'
        })
      }));
      this.editpolygonSource.addFeature(polygonFeature);
      // 地图geojson图层
      const jsonlayer = new VectorLayer({
        source: this.jsonSource,
        className: 'editjson',
        zIndex: 3
      });
      this.jsonSource.forEachFeature(feature => {
        feature.setStyle(new Style({
          stroke: new StyleStroke({
            color: 'rgba(5, 146, 232, 1)',
            width: 1,
            lineDash: [4]
          }),
          fill: new StyleFill({
            color: 'rgba(0, 0, 0, 0)'
          })
        }));
      });
      this.editmapcontainer = this.$refs.editmap;
      this.editmap = new Map({
        layers: [this.editiconLayer, this.editpolygonLayer, jsonlayer],
        target: this.editmapcontainer,
        view: new View({
          center: transform(this.center, 'EPSG:4326', 'EPSG:3857'),
          minZoom: this.minZoom,
          maxZoom: this.maxZoom,
          zoom: this.zoom
        }),
        controls: defaults({
          attribution: false
        })
      });
      this.editmap.getView().on('change:resolution', this.editviewchangeresolution);

      // 添加变换事件
      let transforminteration = new Transform({
        enableRotatedTransform: false,
        addCondition: shiftKeyOnly,
        layers: [this.editpolygonLayer],
        hitTolerance: 2,
        translateFeature: true,
        scale: true,
        rotate: false,
        keepAspectRatio: always,
        keepRectangle: false,
        translate: true,
        stretch: true
      });
      this.transforminteration = transforminteration;
      this.editmap.addInteraction(transforminteration);

      // 监听平移、缩放start事件
      transforminteration.on(['select', 'translatestart', 'scalestart'], function (e) {
        let extent = that.editpolygonSource.getExtent();
        const scale = that.getTransformImagescale(extent).scale;
        that.editiconSource.getFeatures()[0].setStyle(new Style({
          image: new StyleIcon({
            src: that.editimg,
            scale: scale,
            anchor: [0.5, 0.5]
          })
        }));
      });
      // 监听平移事件
      transforminteration.on('translating', function (e) {
        let extent = e.feature.getGeometry().getExtent();
        that.editiconSource.getFeatures()[0].setGeometry(new Point(getCenter(extent)));
      });
      // 监听缩放事件
      transforminteration.on('scaling', function (e) {
        let extent = e.feature.getGeometry().getExtent();
        const scale = that.getTransformImagescale(extent).scale;
        that.editiconSource.getFeatures()[0].setStyle(new Style({
          image: new StyleIcon({
            src: that.editimg,
            scale: scale,
            anchor: [0.5, 0.5]
          })
        }));
      });
      let imgUrl = this.mapv2info.form.fillimageindex === '' ? this.mapv2info.form.fillimage[0].http || this.mapv2info.form.fillimage[0].fileUrl : this.fileImageList[this.mapv2info.form.fillimageindex - 1].url;
      if (imgUrl.includes('p.ananas.chaoxing.com')) imgUrl = imgUrl.replace('p.ananas.chaoxing.com', 'museum.chaoxing.com');
      if (imgUrl.includes('p.cldisk.com')) imgUrl = imgUrl.replace('p.cldisk.com', 'museum.chaoxing.com');
      console.log(`imgUrl`, imgUrl);
      let image = new Image();
      image.setAttribute('crossOrigin', 'Anonymous');
      image.src = handleHttp(imgUrl);
      console.log(`image.src`, image.src);
      this.editimg = image.src;
      image.onload = () => {
        that.editimgwdith = image.width;
        that.editimgheight = image.height;
        const scaleinfo = that.getTransformImagescale(jsonExtent);
        // 添加图片feature
        let iconFeature = new Feature({
          geometry: new Point(jsoncenter)
        });
        iconFeature.setStyle(new Style({
          image: new StyleIcon({
            src: image.src,
            scale: scaleinfo.scale,
            anchor: [0.5, 0.5]
          })
        }));
        that.editiconSource.addFeature(iconFeature);
        // 改变polygon extent范围
        let centerpixel = that.map.getPixelFromCoordinate(jsoncenter);
        if (scaleinfo.compare === 0) scaleinfo.extentheight = image.height * scaleinfo.extentwidth / image.width;
        if (scaleinfo.compare === 1) scaleinfo.extentwidth = image.width * scaleinfo.extentheight / image.height;
        let leftBottomcoord = that.map.getCoordinateFromPixel([centerpixel[0] - scaleinfo.extentwidth / 2, centerpixel[1] + scaleinfo.extentheight / 2]);
        let rightTopcoord = that.map.getCoordinateFromPixel([centerpixel[0] + scaleinfo.extentwidth / 2, centerpixel[1] - scaleinfo.extentheight / 2]);
        let newPolygonextent = [...leftBottomcoord, ...rightTopcoord];
        polygonFeature.setGeometry(new Polygon([that.extentToPolygonCoords(newPolygonextent)]));
      };
    },
    editviewchangeresolution(evt) {
      // console.log(`editviewchangeresolution`, evt)
      let extent = this.editpolygonSource.getExtent();
      const scale = this.getTransformImagescale(extent).scale;
      this.editiconSource.getFeatures()[0].setStyle(new Style({
        image: new StyleIcon({
          src: this.editimg,
          scale: scale,
          anchor: [0.5, 0.5]
        })
      }));
    },
    /* 裁剪地图 填充图片事件 */
    clipImageHandle() {
      // 不是裁剪地图 不做任何操作
      console.log(`this.editMapflag`, this.editMapflag);
      if (!this.editMapflag) return;
      // 核心修复1：获取【设备像素比】，处理显示器缩放/布局缩放问题，全局复用
      const pixelRatio = window.devicePixelRatio || 1;
      let that = this;
      // 清除选中feature
      console.log(`this.transforminteration`, this.transforminteration);
      console.log(`this.transforminteration.getFeatures()`, this.transforminteration.getFeatures());
      this.transforminteration.setActive(false);
      this.editmap.getLayers().getArray().forEach(item => {
        if (item.getClassName() === 'editicon') {
          // 获取当前图层渲染器
          let itemRender = item.getRenderer();
          itemRender.context.globalCompositeOperation = 'destination-in';
          this.jsonSource.forEachFeature(feature => {
            olRender.getVectorContext(itemRender).drawFeature(feature, new Style({
              fill: new StyleFill({
                color: 'red'
              })
            }));
          });
          itemRender.context.globalCompositeOperation = 'source-over';
          let iextent = this.jsonSource.getExtent();
          let image = new Image();
          image.setAttribute('crossOrigin', 'Anonymous');
          image.src = itemRender.context.canvas.toDataURL('image/png');
          let drawcanvas = document.createElement('canvas');
          let drawcontext = drawcanvas.getContext('2d');
          let Resolution = this.editmap.getView().getResolution();

          // 计算图片的宽度高度
          let w = Math.abs(iextent[2] - iextent[0]) / Resolution * pixelRatio;
          let h = Math.abs(iextent[3] - iextent[1]) / Resolution * pixelRatio;
          let jsonRightTopPixel = this.editmap.getPixelFromCoordinate([iextent[2], iextent[3]]);
          let sx = jsonRightTopPixel[0] * pixelRatio - w;
          let sy = jsonRightTopPixel[1] * pixelRatio;
          drawcanvas.width = w + 10;
          drawcanvas.height = h + 10;
          //清理画布，便于重新绘制 
          setTimeout(() => {
            drawcontext.clearRect(0, 0, w, h);
            drawcontext.drawImage(image, sx, sy, w, h, 0, 0, w, h);
            that.clipImageUrl = drawcontext.canvas.toDataURL('image/webp', 0.8);
            that.editMapflag = false;
            that.map.getLayers().getArray().forEach(item => {
              if (item.getClassName() === 'static') {
                item.setVisible(true);
                item.setSource(that.setSourceImagestatic(that.clipImageUrl, transformExtent(that.extent, 'EPSG:4326', 'EPSG:3857')));
              }
              if (item.getClassName() === 'json') item.setOpacity(0);
            });
            that.SET_MAPFORMITEM({
              fillclipimage: that.clipImageUrl
            });
            that.SET_MAPFORMITEM({
              clipflag: false
            });
          }, 1000);
        }
      });
    },
    /* 选择填充图片模版或上传填充图片时 触发 */
    changeMapfillImage(val) {
      console.log(`val`, val);
      console.log(`val`, typeof val);
      console.log(`this.editmap`, this.editmap);
      if (this.mapv2info.form.mapmodetype === '静态地图') return;
      // 若删除图片 不做操作
      if (typeof val !== 'number' && val.length === 0) return;
      if (this.editmap === '') {
        this.createEditMap();
        return;
      }
      if (this.editmap !== '') {
        this.editMapflag = true;
        this.transforminteration.setActive(true);
        let that = this;
        let jsonExtent = this.jsonSource.getExtent();
        let jsoncenter = getCenter(jsonExtent);
        this.jsonSource.forEachFeature(feature => {
          feature.setStyle(this.jsonstyleFunction());
        });
        let imgUrl = typeof val === 'number' ? this.fileImageList[val - 1].url : val[0].http || val[0].fileUrl;
        if (imgUrl.includes('p.ananas.chaoxing.com')) imgUrl = imgUrl.replace('p.ananas.chaoxing.com', 'museum.chaoxing.com');
        if (imgUrl.includes('p.cldisk.com')) imgUrl = imgUrl.replace('p.cldisk.com', 'museum.chaoxing.com');
        let image = new Image();
        image.setAttribute('crossOrigin', 'Anonymous');
        image.src = handleHttp(imgUrl);
        console.log(`image.src`, image.src);
        this.editimg = image.src;
        image.onload = () => {
          that.editimgwdith = image.width;
          that.editimgheight = image.height;
          const scaleinfo = that.getTransformImagescale(jsonExtent);
          // 改变图片url
          that.editiconSource.getFeatures()[0].setGeometry(new Point(jsoncenter));
          that.editiconSource.getFeatures()[0].setStyle(new Style({
            image: new StyleIcon({
              src: image.src,
              scale: scaleinfo.scale,
              anchor: [0.5, 0.5]
            })
          }));
          // 改变polygon extent范围
          let centerpixel = that.map.getPixelFromCoordinate(jsoncenter);
          if (scaleinfo.compare === 0) scaleinfo.extentheight = image.height * scaleinfo.extentwidth / image.width;
          if (scaleinfo.compare === 1) scaleinfo.extentwidth = image.width * scaleinfo.extentheight / image.height;
          let leftBottomcoord = that.map.getCoordinateFromPixel([centerpixel[0] - scaleinfo.extentwidth / 2, centerpixel[1] + scaleinfo.extentheight / 2]);
          let rightTopcoord = that.map.getCoordinateFromPixel([centerpixel[0] + scaleinfo.extentwidth / 2, centerpixel[1] - scaleinfo.extentheight / 2]);
          let newPolygonextent = [...leftBottomcoord, ...rightTopcoord];
          that.editpolygonSource.getFeatures()[0].setGeometry(new Polygon([that.extentToPolygonCoords(newPolygonextent)]));
        };
      }
    },
    /* 切换静态地图/填充地图 触发 */
    changeMapmodeType(val) {
      if (val === '静态地图') {
        this.editMapflag = false;
        if (this.mapv2info.form.static_img.length === 0) {
          this.staticimageHandle('', this.setSourceImagestatic('', []));
        } else {
          this.staticimageHandle(this.mapv2info.form.static_img, this.setSourceImagestatic(getImg(this.mapv2info.form.static_img[0]), this.jsonSource.getExtent()));
        }
      }
      if (val === '填充地图') {
        this.changeMapfilltype(this.mapv2info.form.filltype);
      }
    },
    /* 地图图片层级数据 触发 */
    staticimageHandle(val, source) {
      this.map.getLayers().getArray().forEach(item => {
        if (item.getClassName() === 'static') {
          if (val === '') {
            item.setVisible(false);
            item.setSource(this.setSourceImagestatic('', []));
          } else {
            item.setVisible(true);
            item.setSource(source);
          }
        }
        if (item.getClassName() === 'json') {
          if (val === '') {
            item.setOpacity(1);
            item.getSource().forEachFeature(feature => {
              feature.setStyle(this.jsonstyleFunction());
            });
          } else {
            item.setOpacity(0);
          }
        }
      });
    },
    extentToPolygonCoords(extent) {
      return [[extent[0], extent[1]],
      // 左上角
      [extent[2], extent[1]],
      // 右上角
      [extent[2], extent[3]],
      // 右下角
      [extent[0], extent[3]],
      // 左下角
      [extent[0], extent[1]] // 闭合
      ];
    },
    getTransformImagescale(extent) {
      // 计算多边形的宽度和高度
      let Resolution = this.editmap.getView().getResolution();
      const leftbottom = this.map.getPixelFromCoordinate([extent[0], extent[1]]);
      const righttop = this.map.getPixelFromCoordinate([extent[2], extent[3]]);
      const Width = Math.abs(extent[2] - extent[0]) / Resolution;
      const Height = Math.abs(extent[3] - extent[1]) / Resolution;
      // 计算图标缩放比例
      const scaleX = Width / this.editimgwdith;
      const scaleY = Height / this.editimgheight;
      let scaleinfo = {
        scale: Math.max(scaleX, scaleY),
        extentwidth: leftbottom[0] - righttop[0],
        extentheight: leftbottom[1] - righttop[1],
        // 0按宽度等比 1按高度等比
        compare: Math.max(scaleX, scaleY) === scaleX ? 0 : 1
      };
      return scaleinfo;
    },
    /* 创建图片图层 */
    setSourceImagestatic(url, extent) {
      return new SourceImagestatic({
        url: url,
        projection: 'EPSG:3857',
        imageExtent: extent
      });
    },
    /* 多个行政区域geojson合并数据 turf.js*/
    geoJsonUnion(features) {
      let geojsonData = JSON.parse(new GeoJSON().writeFeatures(features));
      const featureCollection = geojsonData.features;
      let polygons = [];
      featureCollection.forEach(feature => {
        if (feature.geometry.type === 'MultiPolygon') {
          feature.geometry.coordinates.forEach(coordinates => {
            polygons.push(turf.polygon(coordinates));
          });
        } else if (feature.geometry.type === 'Polygon') {
          polygons.push(turf.polygon(feature.geometry.coordinates));
        }
      });
      let mergedFeature = turf.union(turf.featureCollection(polygons));
      const olFeature = new GeoJSON().readFeature(mergedFeature);
      return olFeature;
      // this.jsonSource = new VectorSource({ features: [olFeature] })
      // this.jsonLayer.setSource(this.jsonSource)
    },
    /* 调整图片范围事件 */
    setPolygonLayer(val) {
      console.log(`staticImageLayer`, this.staticImageLayer.getSource().getImageExtent());
      console.log(`jsonLayer`, this.jsonLayer.getSource().getExtent());
      let that = this;
      const imageExtent = this.staticImageLayer.getSource().getImageExtent();
      const jsonExtent = this.jsonLayer.getSource().getExtent();
      if (JSON.stringify(imageExtent) !== JSON.stringify(jsonExtent)) {
        this.staticImageLayer.setSource(this.setSourceImagestatic(val, jsonExtent));
        this.SET_MAPFORMITEM({
          transform_extent: transformExtent(jsonExtent, 'EPSG:3857', 'EPSG:4326')
        });
      }

      // 地图放置控制图片的矩形图层
      this.polygonSource = new VectorSource();
      this.polygonLayer = new VectorLayer({
        source: this.polygonSource,
        className: 'mappolygon',
        zIndex: 11
      });
      let polygonFeature = new Feature({
        geometry: new Polygon([this.extentToPolygonCoords(jsonExtent)]),
        type: 'dragpolygon',
        id: 1
      });
      polygonFeature.setStyle(new Style({
        stroke: new StyleStroke({
          color: 'rgba(5, 146, 232, 1)',
          width: 1,
          lineDash: [5, 2]
        }),
        fill: new StyleFill({
          color: 'rgba(0, 0, 0, 0)'
        })
      }));
      this.polygonSource.addFeature(polygonFeature);
      this.map.addLayer(this.polygonLayer);
      let toolswrapDom = document.getElementById('toolswrap');
      toolswrapDom.classList.add('show', 'extent');
      this.toolswrap = new Overlay({
        position: [jsonExtent[2], jsonExtent[3]],
        element: document.getElementById('toolswrap')
      });
      this.map.addOverlay(this.toolswrap);

      // 添加变换事件
      let transforminteration = new Transform({
        enableRotatedTransform: false,
        addCondition: shiftKeyOnly,
        // layers: [this.polygonLayer],
        hitTolerance: 2,
        translateFeature: true,
        scale: true,
        rotate: false,
        keepAspectRatio: always,
        keepRectangle: false,
        translate: true,
        stretch: true
      });
      this.transforminteration = transforminteration;
      this.map.addInteraction(transforminteration);

      // 监听平移、缩放start事件
      transforminteration.on(['select', 'translatestart', 'scalestart'], function (e) {});
      // 监听平移、缩放事件
      transforminteration.on(['translating', 'scaling'], function (e) {
        let extent = e.feature.getGeometry().getExtent();
        that.staticImageLayer.setSource(that.setSourceImagestatic(that.staticimage, extent));
        that.toolswrap.setPosition([extent[2], extent[3]]);
      });
      // 监听平移、缩放结束事件
      transforminteration.on(['translateend', 'scaleend'], function (e) {
        let extent = e.feature.getGeometry().getExtent();
        that.staticImageLayer.setSource(that.setSourceImagestatic(that.staticimage, extent));
      });
    },
    /* 调整图片范围 */
    adjustExtent() {
      if (this.staticimage === '') {
        ElMessage({
          message: '请先上传图片',
          type: 'warning'
        });
        return;
      }
      this.jsonLayer.setVisible(true);
      this.jsonLayer.setOpacity(1);
      this.defaultlayer.setVisible(true);
      this.setPolygonLayer(this.staticimage);
    },
    /* 关闭调整图片范围事件 */
    confirmextent() {
      let extent = transformExtent(this.polygonLayer.getSource().getExtent(), 'EPSG:3857', 'EPSG:4326');
      this.SET_MAPVIEWITEM({
        extent: extent
      });
      this.SET_MAPFORMITEM({
        transform_extent: extent.join(',')
      });
      this.toolswrap.setPosition(undefined);
      this.toolswrap = null;
      this.map.getLayers().getArray().forEach(item => {
        if (item.getClassName() === 'mappolygon') this.map.removeLayer(item);
      });
      this.polygonSource = '';
      this.polygonLayer = [];
      this.map.getInteractions().getArray().forEach(interaction => {
        if (interaction instanceof Transform) this.map.removeInteraction(interaction);
      });
      this.jsonLayer.setVisible(false);
      this.defaultlayer.setVisible(false);
    },
    /**
     * 单个点位样式改变事件
     * @param {Object} val 数据
     * @date 2025-06-04
     */
    setsinglePointStyle(val) {
      let item = val.item;
      const {
        text,
        pic,
        icon,
        isFollowglobal,
        pointStyleIndex
      } = val.data;
      let iconarr = this.iconSource.getFeatures();
      for (let i = 0; i < iconarr.length; i++) {
        const feature = iconarr[i];
        if (feature.get('id') === item.id) {
          let pointStyle;
          if (!isFollowglobal) {
            feature.set('isFollowglobal', isFollowglobal);
            feature.set('pointStyleIndex', pointStyleIndex);
            // 不跟随全局样式设置
            pointStyle = this.getStyle({
              name: item.place_name,
              image: item[4].length > 0 ? getImg(item[4][0]) : this.defaulticon,
              icon: this.defaulticon
            }, pointStyleIndex, false, false, {
              spic: pic,
              stext: text,
              sicon: icon
            });
          } else {
            pointStyle = this.getStyle({
              name: item.place_name,
              image: item[4].length > 0 ? getImg(item[4][0]) : this.defaulticon,
              icon: this.defaulticon
            }, this.style.pointStyleIndex, false, false);
          }
          feature.setStyle(pointStyle);
        }
      }
    },
    /**
     * 地图投影数据
     * @param {Object} data 数据
     * @date 2025-06-26
     */
    changeMapShadowList(val) {
      console.log(`map-changeMapShadowList`, val);
      console.log(`val.shadowFlag`, val.shadowFlag);
      if (val.shadowFlag === undefined) return;
      this.map.getLayers().getArray().forEach(item => {
        if (item.getClassName() === 'shadowjson') {
          item.setVisible(val.shadowFlag);
        }
      });
      if (!val.shadowFlag) return;
      if (this.shadowjsonSource === '') {
        // 若是总分区域 需要先合并
        const shadowFeatures = _.cloneDeep(this.jsonSource.getFeatures());
        let mergedData;
        if (shadowFeatures.length > 1) {
          mergedData = this.geoJsonUnion(shadowFeatures);
          mergedData.set('shadow', true);
        } else {
          shadowFeatures[0].set('shadow', true);
        }
        this.shadowjsonSource = new VectorSource({
          features: mergedData !== undefined ? [mergedData] : shadowFeatures
        });
        this.shadowjsonLayer.setSource(this.shadowjsonSource);
      }
      let shadowList = [];
      for (let i = val.data.length - 1; i >= 0; i--) {
        const item = val.data[i];
        let obj = {};
        item.forEach(child => {
          obj[child.alias] = child.compt === 'numberinput' ? Number(child.values[0].val) : child.values[0].val;
        });
        shadowList.push(obj);
      }
      let self = this;
      this.shadowjsonLayer.getSource().getFeatures()[0].setStyle(function (feature) {
        return new Style({
          renderer(coordinate, state) {
            const depth = self.getArrayDepth(coordinate);
            coordinate.forEach(item => {
              let arr = depth === 4 ? item[0] : item;
              const ctx = state.context;
              shadowList.forEach(item => {
                let obj = {
                  ...item,
                  coodArr: arr
                };
                obj.lineDash = item.lineDash === '0' ? [] : item.lineDash.split(',').map(Number);
                self.addOutlineShadow(ctx, obj);
              });
            });
          }
        });
      });
    },
    /**
     * 添加投影函数
     * @param {Object} option 数据
     * @date 2025-06-26
     */
    addOutlineShadow(ctx, option) {
      // 设置属性控制图形的外观
      ctx.fillStyle = option.fillStyle || 'transparent';
      ctx.strokeStyle = option.strokeStyle || 'transparent';
      ctx.lineWidth = option.lineWidth || 1;
      ctx.setLineDash(option.lineDash);

      //  设置Y轴偏移量
      ctx.shadowOffsetY = option.shadowOffsetY || 20;
      //  设置X轴偏移量
      ctx.shadowOffsetX = option.shadowOffsetX || 2;
      //  设置模糊度
      ctx.shadowBlur = option.shadowBlur || 2;
      //  设置阴影颜色
      ctx.shadowColor = option.shadowColor || '#000';
      ctx.beginPath();
      let arr = option.coodArr || [];
      for (let i = 0; i < arr.length; i++) {
        const data = arr[i];
        if (i === 0) {
          ctx.moveTo(data[0] - 0, data[1] + option.y);
        } else {
          ctx.lineTo(data[0] - 0, data[1] + option.y);
        }
      }
      ctx.closePath();
      ctx.fill();
      ctx.stroke();
    },
    // 辅助函数：获取数组的嵌套深度
    getArrayDepth(arr) {
      // 如果不是数组，深度为0
      if (!Array.isArray(arr)) return 0;
      // 递归计算子数组的最大深度，加1（当前层）
      return 1 + Math.max(...arr.map(item => this.getArrayDepth(item)), 0);
    },
    /**
     * 地图添加素材
     * @param {Object} data 素材信息
     * @date 2025-06-26
     */
    addDecorationpoint(data) {
      console.log(`data`, data);
      const pointCoord = this.map.getCoordinateFromPixel([data.left, data.top]);
      console.log(`pointCoord`, pointCoord);
      const item = data.itemformdata;
      let obj = {
        name: item.material_name,
        image: getImg(item.picture_upload[0]),
        icon: this.defaulticon
      };
      let point = new Feature({
        geometry: new Point(pointCoord),
        id: data.id,
        type: 'decoration',
        name: obj.name,
        image: obj.image
      });
      point.setStyle(new Style({
        image: new StyleIcon({
          src: obj.image,
          anchor: [0.5, 0.5],
          scale: 1,
          rotateWithView: true
        }),
        zIndex: 1
      }));
      console.log(`point`, point);
      this.decorationSource.addFeature(point);
    },
    resetMap() {
      this.map.getView().animate({
        center: transform(this.center, 'EPSG:4326', 'EPSG:3857'),
        rotation: 0,
        duration: 1000
      });
    },
    /**
     * 标准模版 列表点击点位交互效果
     * @date 2026-05-08
     */
    resetPointzIndex(item) {
      let allfeatures = this.iconSource.getFeatures();
      allfeatures.forEach(feature => {
        let obj = feature.getProperties();
        const isHasFollow = obj.isFollowglobal === undefined || obj.isFollowglobal ? true : false;
        let sIndex = isHasFollow ? this.style.pointStyleIndex : obj.pointStyleIndex;
        if (feature.get('zIndex') > 2) {
          obj.zIndex = 1;
          feature.set('zIndex', 1);
        }
        if (feature.get('id') === item.id) {
          obj.zIndex = 99;
          feature.set('zIndex', 99);
        }
        feature.setStyle(this.getStyle(obj, sIndex, false, false, isHasFollow ? {} : obj));
      });
    }
  }
};